import React, { useState, useEffect, useCallback } from 'react';
import { collection, getDocs, getDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../hooks/useAuth';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { PRODUCT_TYPES, PILE_MODELS, FABRIC_TYPES, MECHANISM_TYPES, SYSTEM_TYPES, MOTOR_TYPES, REMOTE_TYPES, ACCESSORIES, DIRECTION_TYPES, DIKEY_DIRECTION_TYPES, MOUNTING_TYPES, TUL_PILE_MODELS, KANAT_PILE_MODELS, KATLAMALI_PERDE_MEKANIZMA_TIPLERI, JALUZI_SISTEM_TIPLERI } from '../../constants';
import { formatPrice, calculatePileDensity, calculateRustikRayLineTotal } from '../../utils';
import { sendSingleOrderWhatsAppMessage } from '../../utils/whatsappUtils';
import './OrderForm.css';

const OrderForm = ({
  isAddingOrder,
  editingOrderId,
  selectedProductType,
  newOrder,
  isLoading,
  customerInfo,
  customerId,
  onProductTypeChange,
  onFieldChange,
  onSubmit,
  onCancel,
  pileModels = [], // Pile modelleri prop olarak gelebilir (OrderDetails'dan)
  isWholesale = false, // Bayi modu: toptan fiyat kullan
  rustikFormSessionKey = 0
}) => {
  const { user } = useAuth();
  const [selectedFirma, setSelectedFirma] = useState('');
  const [selectedFirmaKumas, setSelectedFirmaKumas] = useState('');
  const [selectedFirmaMekanizma, setSelectedFirmaMekanizma] = useState('');
  const [selectedFirmaMotor, setSelectedFirmaMotor] = useState('');
  const [selectedFirmaAksesuar, setSelectedFirmaAksesuar] = useState('');

  const [lastSentFirma, setLastSentFirma] = useState(null);
  const [lastSentFirmaKumas, setLastSentFirmaKumas] = useState(null);
  const [lastSentFirmaMekanizma, setLastSentFirmaMekanizma] = useState(null);
  const [lastSentFirmaMotor, setLastSentFirmaMotor] = useState(null);
  const [lastSentFirmaAksesuar, setLastSentFirmaAksesuar] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [localPileModels, setLocalPileModels] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [showExtraCost, setShowExtraCost] = useState(false);
  const [showBaseCost, setShowBaseCost] = useState(false);
  const [showMountingCost, setShowMountingCost] = useState(false);
  const [showAyakUcretiCost, setShowAyakUcretiCost] = useState(false);

  // Sayısal alanlarda negatif işareti ve 'e' karakterini engelle
  const handleNumericKeyDown = (e) => {
    if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
      e.preventDefault();
    }
  };

  const [adminSettings, setAdminSettings] = useState({
    sPilePrice: 0, sPileWholesale: 0, sPileCost: 0, american2Price: 0, american2Wholesale: 0, american2Cost: 0, american3Price: 0, american3Wholesale: 0, american3Cost: 0,
    kapsulPrice: 0, kapsulWholesale: 0, kapsulCost: 0,
    kanatSPilePrice: 0, kanatSPileWholesale: 0, kanatSPileCost: 0, kanatAmerican2Price: 0, kanatAmerican2Wholesale: 0, kanatAmerican2Cost: 0, kanatAmerican3Price: 0, kanatAmerican3Wholesale: 0, kanatAmerican3Cost: 0,
    kanatKapsulPrice: 0, kanatKapsulWholesale: 0, kanatKapsulCost: 0,
    motorCurrency: 'USD', zigilPrice: 0, zigilWholesale: 0, zigilCost: 0, reduktorPrice: 0, reduktorWholesale: 0, reduktorCost: 0, kurdelaPrice: 0, kurdelaWholesale: 0, kurdelaCost: 0,
    metalZigilPrice: 0, metalZigilWholesale: 0, metalZigilCost: 0, metalReduktorPrice: 0, metalReduktorWholesale: 0, metalReduktorCost: 0, ikiCamArasiPrice: 0, ikiCamArasiWholesale: 0, ikiCamArasiCost: 0,
    storJumboPrice: 0, storJumboWholesale: 0, storJumboCost: 0, storAltEtekDilimPrice: 0, storAltEtekDilimWholesale: 0, storAltEtekDilimCost: 0, storKapaliKasaPrice: 0, storKapaliKasaWholesale: 0, storKapaliKasaCost: 0,
    storAltEtekLazerPrice: 0, storAltEtekLazerWholesale: 0, storAltEtekLazerCost: 0, storDekoratifLamaPrice: 0, storDekoratifLamaWholesale: 0, storDekoratifLamaCost: 0, storDekoratifKasaPrice: 0, storDekoratifKasaWholesale: 0, storDekoratifKasaCost: 0,
    storAltEtekBeyazIsPrice: 0, storAltEtekBeyazIsWholesale: 0, storAltEtekBeyazIsCost: 0,
    zebraJumboPrice: 0, zebraJumboWholesale: 0, zebraJumboCost: 0, zebraAltEtekDilimPrice: 0, zebraAltEtekDilimWholesale: 0, zebraAltEtekDilimCost: 0, zebraKapaliKasaPrice: 0, zebraKapaliKasaWholesale: 0, zebraKapaliKasaCost: 0,
    dikeyFonPrice: 0, dikeyFonWholesale: 0, dikeyFonCost: 0, dikeyFonList: [],
    katlamaliMekanizmaList: [],
    rustikAyakModelList: [],
    rustikAyakCapList: [],
    rustikAyakUzunlukList: [],
    rustikAyakRenkKoduList: [],
    // Per-product motor settings
    storMotorSettings: { cost: 0, retail: 0, wholesale: 0, currency: 'USD', specialRateRetail: 0, specialRateWholesale: 0 },
    zebraMotorSettings: { cost: 0, retail: 0, wholesale: 0, currency: 'USD', specialRateRetail: 0, specialRateWholesale: 0 },
    ahsapJaluziMotorSettings: { cost: 0, retail: 0, wholesale: 0, currency: 'USD', specialRateRetail: 0, specialRateWholesale: 0 },
    metalJaluziMotorSettings: { cost: 0, retail: 0, wholesale: 0, currency: 'USD', specialRateRetail: 0, specialRateWholesale: 0 },
    dikeyPerdeMotorSettings: { cost: 0, retail: 0, wholesale: 0, currency: 'USD', specialRateRetail: 0, specialRateWholesale: 0 },
    dikeyPvcMotorSettings: { cost: 0, retail: 0, wholesale: 0, currency: 'USD', specialRateRetail: 0, specialRateWholesale: 0 },
    dikeyStorMotorSettings: { cost: 0, retail: 0, wholesale: 0, currency: 'USD', specialRateRetail: 0, specialRateWholesale: 0 },
    katlamaliPerdeMotorSettings: { cost: 0, retail: 0, wholesale: 0, currency: 'USD', specialRateRetail: 0, specialRateWholesale: 0 }
  });
  const [exchangeRates, setExchangeRates] = useState({ USD: 1, EUR: 1 });

  useEffect(() => {
    if (selectedProductType !== 'rustik' || rustikFormSessionKey === 0) return;
    setShowBaseCost(false);
    setShowMountingCost(false);
    setShowAyakUcretiCost(false);
  }, [rustikFormSessionKey, selectedProductType]);

  const toggleRustikExtraCost = (field, idx) => {
    const list = newOrder[field] || [];
    const newList = list.map((item, i) =>
      i === idx ? { ...item, showCost: !item.showCost } : item
    );
    onFieldChange(field, newList);
  };

  // Ayarları ve Kurları Çek
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingsRef = doc(db, 'settings', 'global');
        const docSnap = await getDoc(settingsRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setAdminSettings({
            sPilePrice: Number(data.sPilePrice) || 0,
            sPileWholesale: Number(data.sPileWholesale) || 0,
            sPileCost: Number(data.sPileCost) || 0,
            american2Price: Number(data.american2Price) || 0,
            american2Wholesale: Number(data.american2Wholesale) || 0,
            american2Cost: Number(data.american2Cost) || 0,
            american3Price: Number(data.american3Price) || 0,
            american3Wholesale: Number(data.american3Wholesale) || 0,
            american3Cost: Number(data.american3Cost) || 0,
            kapsulPrice: Number(data.kapsulPrice) || 0,
            kapsulWholesale: Number(data.kapsulWholesale) || 0,
            kapsulCost: Number(data.kapsulCost) || 0,
            kanatSPilePrice: data.kanatSPilePrice !== undefined ? Number(data.kanatSPilePrice) : (Number(data.sPilePrice) || 0),
            kanatSPileWholesale: data.kanatSPileWholesale !== undefined ? Number(data.kanatSPileWholesale) : (Number(data.sPileWholesale) || 0),
            kanatSPileCost: data.kanatSPileCost !== undefined ? Number(data.kanatSPileCost) : (Number(data.sPileCost) || 0),
            kanatAmerican2Price: data.kanatAmerican2Price !== undefined ? Number(data.kanatAmerican2Price) : (Number(data.american2Price) || 0),
            kanatAmerican2Wholesale: data.kanatAmerican2Wholesale !== undefined ? Number(data.kanatAmerican2Wholesale) : (Number(data.american2Wholesale) || 0),
            kanatAmerican2Cost: data.kanatAmerican2Cost !== undefined ? Number(data.kanatAmerican2Cost) : (Number(data.american2Cost) || 0),
            kanatAmerican3Price: data.kanatAmerican3Price !== undefined ? Number(data.kanatAmerican3Price) : (Number(data.american3Price) || 0),
            kanatAmerican3Wholesale: data.kanatAmerican3Wholesale !== undefined ? Number(data.kanatAmerican3Wholesale) : (Number(data.american3Wholesale) || 0),
            kanatAmerican3Cost: data.kanatAmerican3Cost !== undefined ? Number(data.kanatAmerican3Cost) : (Number(data.american3Cost) || 0),
            kanatKapsulPrice: data.kanatKapsulPrice !== undefined ? Number(data.kanatKapsulPrice) : (Number(data.kapsulPrice) || 0),
            kanatKapsulWholesale: data.kanatKapsulWholesale !== undefined ? Number(data.kanatKapsulWholesale) : (Number(data.kapsulWholesale) || 0),
            kanatKapsulCost: data.kanatKapsulCost !== undefined ? Number(data.kanatKapsulCost) : (Number(data.kapsulCost) || 0),
            motorCurrency: data.motorCurrency || 'USD',
            zigilPrice: Number(data.zigilPrice) || 0,
            zigilWholesale: Number(data.zigilWholesale) || 0,
            zigilCost: Number(data.zigilCost) || 0,
            reduktorPrice: Number(data.reduktorPrice) || 0,
            reduktorWholesale: Number(data.reduktorWholesale) || 0,
            reduktorCost: Number(data.reduktorCost) || 0,
            kurdelaPrice: Number(data.kurdelaPrice) || 0,
            kurdelaWholesale: Number(data.kurdelaWholesale) || 0,
            kurdelaCost: Number(data.kurdelaCost) || 0,
            metalZigilPrice: Number(data.metalZigilPrice) || 0,
            metalZigilWholesale: Number(data.metalZigilWholesale) || 0,
            metalZigilCost: Number(data.metalZigilCost) || 0,
            metalReduktorPrice: Number(data.metalReduktorPrice) || 0,
            metalReduktorWholesale: Number(data.metalReduktorWholesale) || 0,
            metalReduktorCost: Number(data.metalReduktorCost) || 0,
            ikiCamArasiPrice: Number(data.ikiCamArasiPrice) || 0,
            ikiCamArasiWholesale: Number(data.ikiCamArasiWholesale) || 0,
            ikiCamArasiCost: Number(data.ikiCamArasiCost) || 0,
            storJumboPrice: Number(data.storJumboPrice) || 0,
            storJumboWholesale: Number(data.storJumboWholesale) || 0,
            storJumboCost: Number(data.storJumboCost) || 0,
            storAltEtekDilimPrice: Number(data.storAltEtekDilimPrice) || 0,
            storAltEtekDilimWholesale: Number(data.storAltEtekDilimWholesale) || 0,
            storAltEtekDilimCost: Number(data.storAltEtekDilimCost) || 0,
            storKapaliKasaPrice: Number(data.storKapaliKasaPrice) || 0,
            storKapaliKasaWholesale: Number(data.storKapaliKasaWholesale) || 0,
            storKapaliKasaCost: Number(data.storKapaliKasaCost) || 0,
            storAltEtekLazerPrice: Number(data.storAltEtekLazerPrice) || 0,
            storAltEtekLazerWholesale: Number(data.storAltEtekLazerWholesale) || 0,
            storAltEtekLazerCost: Number(data.storAltEtekLazerCost) || 0,
            storDekoratifLamaPrice: Number(data.storDekoratifLamaPrice) || 0,
            storDekoratifLamaWholesale: Number(data.storDekoratifLamaWholesale) || 0,
            storDekoratifLamaCost: Number(data.storDekoratifLamaCost) || 0,
            storDekoratifKasaPrice: Number(data.storDekoratifKasaPrice) || 0,
            storDekoratifKasaWholesale: Number(data.storDekoratifKasaWholesale) || 0,
            storDekoratifKasaCost: Number(data.storDekoratifKasaCost) || 0,
            storAltEtekBeyazIsPrice: Number(data.storAltEtekBeyazIsPrice) || 0,
            storAltEtekBeyazIsWholesale: Number(data.storAltEtekBeyazIsWholesale) || 0,
            storAltEtekBeyazIsCost: Number(data.storAltEtekBeyazIsCost) || 0,
            zebraJumboPrice: Number(data.zebraJumboPrice) || 0,
            zebraJumboWholesale: Number(data.zebraJumboWholesale) || 0,
            zebraJumboCost: Number(data.zebraJumboCost) || 0,
            zebraAltEtekDilimPrice: Number(data.zebraAltEtekDilimPrice) || 0,
            zebraAltEtekDilimWholesale: Number(data.zebraAltEtekDilimWholesale) || 0,
            zebraAltEtekDilimCost: Number(data.zebraAltEtekDilimCost) || 0,
            zebraKapaliKasaPrice: Number(data.zebraKapaliKasaPrice) || 0,
            zebraKapaliKasaWholesale: Number(data.zebraKapaliKasaWholesale) || 0,
            zebraKapaliKasaCost: Number(data.zebraKapaliKasaCost) || 0,
            dikeyFonPrice: Number(data.dikeyFonPrice) || 0,
            dikeyFonWholesale: Number(data.dikeyFonWholesale) || 0,
            dikeyFonCost: Number(data.dikeyFonCost) || 0,
            dikeyFonList: data.dikeyFonList || [],
            katlamaliMekanizmaList: data.katlamaliMekanizmaList || [],
            rustikAyakModelList: data.rustikAyakModelList || [],
            rustikAyakCapList: data.rustikAyakCapList || [],
            rustikAyakUzunlukList: data.rustikAyakUzunlukList || [],
            rustikAyakRenkKoduList: data.rustikAyakRenkKoduList || [],
            // Motor Settings Mapping
            storMotorSettings: {
              cost: Number(data.storMotorCost) || 0,
              retail: Number(data.storMotorRetail) || 0,
              wholesale: Number(data.storMotorWholesale) || 0,
              currency: data.storMotorCurrency || 'USD',
              specialRateRetail: Number(data.storMotorSpecialRateRetail) || 0,
              specialRateWholesale: Number(data.storMotorSpecialRateWholesale) || 0
            },
            zebraMotorSettings: {
              cost: Number(data.zebraMotorCost) || 0,
              retail: Number(data.zebraMotorRetail) || 0,
              wholesale: Number(data.zebraMotorWholesale) || 0,
              currency: data.zebraMotorCurrency || 'USD',
              specialRateRetail: Number(data.zebraMotorSpecialRateRetail) || 0,
              specialRateWholesale: Number(data.zebraMotorSpecialRateWholesale) || 0
            },
            ahsapJaluziMotorSettings: {
              cost: Number(data.ahsapJaluziMotorCost) || 0,
              retail: Number(data.ahsapJaluziMotorRetail) || 0,
              wholesale: Number(data.ahsapJaluziMotorWholesale) || 0,
              currency: data.ahsapJaluziMotorCurrency || 'USD',
              specialRateRetail: Number(data.ahsapJaluziMotorSpecialRateRetail) || 0,
              specialRateWholesale: Number(data.ahsapJaluziMotorSpecialRateWholesale) || 0
            },
            metalJaluziMotorSettings: {
              cost: Number(data.metalJaluziMotorCost) || 0,
              retail: Number(data.metalJaluziMotorRetail) || 0,
              wholesale: Number(data.metalJaluziMotorWholesale) || 0,
              currency: data.metalJaluziMotorCurrency || 'USD',
              specialRateRetail: Number(data.metalJaluziMotorSpecialRateRetail) || 0,
              specialRateWholesale: Number(data.metalJaluziMotorSpecialRateWholesale) || 0
            },
            dikeyPerdeMotorSettings: {
              cost: Number(data.dikeyPerdeMotorCost) || 0,
              retail: Number(data.dikeyPerdeMotorRetail) || 0,
              wholesale: Number(data.dikeyPerdeMotorWholesale) || 0,
              currency: data.dikeyPerdeMotorCurrency || 'USD',
              specialRateRetail: Number(data.dikeyPerdeMotorSpecialRateRetail) || 0,
              specialRateWholesale: Number(data.dikeyPerdeMotorSpecialRateWholesale) || 0
            },
            dikeyPvcMotorSettings: {
              cost: Number(data.dikeyPvcMotorCost) || 0,
              retail: Number(data.dikeyPvcMotorRetail) || 0,
              wholesale: Number(data.dikeyPvcMotorWholesale) || 0,
              currency: data.dikeyPvcMotorCurrency || 'USD',
              specialRateRetail: Number(data.dikeyPvcMotorSpecialRateRetail) || 0,
              specialRateWholesale: Number(data.dikeyPvcMotorSpecialRateWholesale) || 0
            },
            dikeyStorMotorSettings: {
              cost: Number(data.dikeyStorMotorCost) || 0,
              retail: Number(data.dikeyStorMotorRetail) || 0,
              wholesale: Number(data.dikeyStorMotorWholesale) || 0,
              currency: data.dikeyStorMotorCurrency || 'USD',
              specialRateRetail: Number(data.dikeyStorMotorSpecialRateRetail) || 0,
              specialRateWholesale: Number(data.dikeyStorMotorSpecialRateWholesale) || 0
            },
            katlamaliPerdeMotorSettings: {
              cost: Number(data.katlamaliPerdeMotorCost) || 0,
              retail: Number(data.katlamaliPerdeMotorRetail) || 0,
              wholesale: Number(data.katlamaliPerdeMotorWholesale) || 0,
              currency: data.katlamaliPerdeMotorCurrency || 'USD',
              specialRateRetail: Number(data.katlamaliPerdeMotorSpecialRateRetail) || 0,
              specialRateWholesale: Number(data.katlamaliPerdeMotorSpecialRateWholesale) || 0
            }
          });
        }
      } catch (err) { }
    };

    const fetchRates = async () => {
      try {
        const res = await fetch('https://open.er-api.com/v6/latest/USD');
        const data = await res.json();
        if (data && data.rates && data.rates.TRY && data.rates.EUR) {
          const usdToTry = data.rates.TRY;
          const eurToTry = data.rates.TRY / data.rates.EUR;
          setExchangeRates({ USD: usdToTry.toFixed(2), EUR: eurToTry.toFixed(2) });
        }
      } catch (err) { }
    };

    fetchSettings();
    fetchRates();
  }, []);

  // Plise seçilince otomatik bir boş satır ekle (eğer liste boşsa)
  useEffect(() => {
    if (selectedProductType === 'plise' && (!newOrder.pliseItems || newOrder.pliseItems.length === 0)) {
      onFieldChange('pliseItems', [{ id: Date.now(), width: '', height: '', usedM2: '1.00', quantity: '1', multisistem: false, rowTotal: '0.00' }]);
    }
  }, [selectedProductType, newOrder.pliseItems, onFieldChange]);

  // Motor Döviz Hesaplaması (Jaluzi, Stor, Zebra vb.)
  useEffect(() => {
    const motorEnabledTypes = ['ahsapJaluzi', 'metalJaluzi', 'stor', 'zebra', 'dikeyPerde', 'dikeyPvc', 'dikeyStor', 'katlamaliPerde'];
    if (motorEnabledTypes.includes(selectedProductType) && newOrder.motorPriceCurrency !== undefined) {
      const typeSettings = adminSettings[`${selectedProductType}MotorSettings`];
      const currency = typeSettings?.currency || 'USD';
      let rate = exchangeRates[currency] || 1;

      // Özel kur kontrolü
      if (isWholesale) {
        if (typeSettings?.specialRateWholesale && typeSettings.specialRateWholesale !== 0) {
          rate = typeSettings.specialRateWholesale;
        }
      } else {
        if (typeSettings?.specialRateRetail && typeSettings.specialRateRetail !== 0) {
          rate = typeSettings.specialRateRetail;
        }
      }

      const motorTL = (Number(newOrder.motorPriceCurrency) * Number(rate)).toFixed(2);
      if (newOrder.motorPrice !== motorTL) {
        onFieldChange('motorPrice', motorTL);
      }
    }
  }, [newOrder.motorPriceCurrency, adminSettings, exchangeRates, selectedProductType, isWholesale, onFieldChange]);

  // Motor seçildiğinde fiyatı otomatik getir
  useEffect(() => {
    const motorEnabledTypes = ['ahsapJaluzi', 'metalJaluzi', 'stor', 'zebra', 'dikeyPerde', 'dikeyPvc', 'dikeyStor', 'katlamaliPerde'];
    if (motorEnabledTypes.includes(selectedProductType) && newOrder.motorType) {
      const typeSettings = adminSettings[`${selectedProductType}MotorSettings`];
      if (typeSettings) {
        const defaultPrice = isWholesale ? (typeSettings.wholesale || typeSettings.retail) : typeSettings.retail;
        if (newOrder.motorPriceCurrency === '' || newOrder.motorPriceCurrency === undefined || newOrder.motorPriceCurrency === 0) {
          if (newOrder.motorPriceCurrency !== defaultPrice) {
            onFieldChange('motorPriceCurrency', defaultPrice);
          }
        }
      }
    }
  }, [newOrder.motorType, newOrder.motorPriceCurrency, selectedProductType, adminSettings, isWholesale, onFieldChange]);

  // Yardımcı fonksiyon: Bayi ise toptan, değilse perakende fiyatını (veya fallback) döndürür
  const getSettingPrice = (baseKey) => {
    let keyToUse = baseKey;
    if (selectedProductType === 'kanat') {
      const kanatKey = `kanat${baseKey.charAt(0).toUpperCase()}${baseKey.slice(1)}`;
      if (adminSettings[`${kanatKey}Price`] !== undefined || adminSettings[`${kanatKey}Wholesale`] !== undefined) {
        keyToUse = kanatKey;
      }
    }
    if (isWholesale) {
      const wholesaleVal = adminSettings[`${keyToUse}Wholesale`];
      if (wholesaleVal !== undefined && wholesaleVal !== null && wholesaleVal !== 0) {
        return wholesaleVal;
      }
      const retailVal = adminSettings[`${keyToUse}Price`];
      if (retailVal !== undefined && retailVal !== null && retailVal !== 0) {
        return retailVal;
      }
      const baseWholesale = adminSettings[`${baseKey}Wholesale`];
      return baseWholesale !== undefined && baseWholesale !== null && baseWholesale !== 0 ? baseWholesale : adminSettings[`${baseKey}Price`];
    }
    const val = adminSettings[`${keyToUse}Price`];
    return val !== undefined && val !== null ? val : adminSettings[`${baseKey}Price`];
  };

  // Yardımcı fonksiyon: Ek ayarların maliyetini döndürür
  const getSettingCost = (baseKey) => {
    if (selectedProductType === 'kanat') {
      const kanatKey = `kanat${baseKey.charAt(0).toUpperCase()}${baseKey.slice(1)}`;
      if (adminSettings[`${kanatKey}Cost`] !== undefined) {
        return Number(adminSettings[`${kanatKey}Cost`]) || 0;
      }
    }
    return Number(adminSettings[`${baseKey}Cost`]) || 0;
  };

  // Dinamik Motor Para Birimi Getir
  const getMotorCurrency = () => {
    const settingsKey = `${selectedProductType}MotorSettings`;
    return adminSettings[settingsKey]?.currency || adminSettings.motorCurrency || 'USD';
  };

  // Firmaları Firestore'dan çek
  useEffect(() => {
    const fetchCompanies = async () => {
      if (!user?.uid) {
        setCompanies([]);
        return;
      }

      try {
        // Artık userId bazlı filtreleme yok, tüm firmaları çek
        const companiesSnapshot = await getDocs(collection(db, 'companies'));
        const companiesList = companiesSnapshot.docs.map(doc => ({
          id: doc.id,
          name: doc.data().name,
          phone: doc.data().phone,
          defaultMessage: doc.data().defaultMessage || "Yeni sipariş bilgileri:"
        }));
        // İsme göre sırala
        companiesList.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        setCompanies(companiesList);
      } catch (error) {
        console.error('Firmalar yüklenirken hata:', error);
        setCompanies([]);
      }
    };

    fetchCompanies();
  }, [user]);

  // Pile modellerini sadece constants'tan al (Firestore'dan çekme)
  useEffect(() => {
    // Sadece constants'taki modelleri kullan
    const constantsModels = Object.entries(
      selectedProductType === 'tul' ? TUL_PILE_MODELS : KANAT_PILE_MODELS
    ).map(([key, modelName]) => ({
      id: `const_${key}`,
      modelName: modelName,
      density: calculatePileDensity(modelName)
    }));
    setLocalPileModels(constantsModels);
  }, [selectedProductType]);

  // Ürün Listesi'nden ürünleri çek (ürün tipine göre filtrele)
  const fetchProductItems = useCallback(async (productType) => {
    if (!productType) {
      setProductItems([]);
      return;
    }
    try {
      const snapshot = await getDocs(collection(db, 'productItems'));
      const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      const filtered = all
        .filter(p => {
          if (productType === 'katlamaliPerde') {
            return p.productType === 'tul' || p.productType === 'kanat' || p.productType === 'katlamaliPerde';
          }
          return p.productType === productType;
        })
        .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'tr'));
      setProductItems(filtered);
    } catch (error) {
      console.error('Ürün listesi yüklenirken hata:', error);
      setProductItems([]);
    }
  }, []);

  useEffect(() => {
    fetchProductItems(selectedProductType);
  }, [selectedProductType, fetchProductItems]);

  // Ürün seçilince adı ve birim fiyatı otomatik doldur
  const handleProductSelect = (productId) => {
    const product = productItems.find(p => p.id === productId);
    if (product) {
      onFieldChange('productName', product.name);

      // isWholesale modunda toptan fiyatı kullan (yoksa birim fiyata fallback)
      // Eğer bir Jaluzi seçiliyse, unitPrice sistem tipine veya varsa ilk geçerli fiyata göre seçilmeli.
      let priceToSet;
      if (isWholesale && selectedProductType === 'ahsapJaluzi') {
        // Jaluzi toptan: sistem tipine göre ilgili toptan fiyatı çek
        const pType = newOrder.sistemTipi;
        if (pType === JALUZI_SISTEM_TIPLERI.merdivenIpli)
          priceToSet = product.merdivenIpliToptan || product.merdivenIpliFiyat || '';
        else if (pType === JALUZI_SISTEM_TIPLERI.kurdeleli)
          priceToSet = product.kurdeleliToptan || product.kurdeleliFiyat || '';
        else if (pType === JALUZI_SISTEM_TIPLERI.merdivenIpliReduktorlu)
          priceToSet = product.merdivenIpliReduktorluToptan || product.merdivenIpliReduktorluFiyat || '';
        else if (pType === JALUZI_SISTEM_TIPLERI.kurdelaliReduktorlu)
          priceToSet = product.kurdelaliReduktorluToptan || product.kurdelaliReduktorluFiyat || '';
        else {
          // Sistem tipi henüz seçilmediyse en büyük toptan fiyatı dene
          priceToSet = product.merdivenIpliToptan || product.kurdeleliToptan ||
            product.merdivenIpliToptan || product.kurdelaliReduktorluToptan ||
            product.merdivenIpliFiyat || product.kurdeleliFiyat || '';
        }
      } else if (isWholesale) {
        // Diğer ürün tipleri: wholesalePrice (yoksa unitPrice fallback)
        priceToSet = (product.wholesalePrice && product.wholesalePrice > 0)
          ? product.wholesalePrice
          : product.unitPrice;
      } else if (selectedProductType === 'ahsapJaluzi') {
        const pType = newOrder.sistemTipi;
        if (pType === JALUZI_SISTEM_TIPLERI.merdivenIpli) priceToSet = product.merdivenIpliFiyat || '';
        else if (pType === JALUZI_SISTEM_TIPLERI.kurdeleli) priceToSet = product.kurdeleliFiyat || '';
        else if (pType === JALUZI_SISTEM_TIPLERI.merdivenIpliReduktorlu) priceToSet = product.merdivenIpliReduktorluFiyat || '';
        else if (pType === JALUZI_SISTEM_TIPLERI.kurdelaliReduktorlu) priceToSet = product.kurdelaliReduktorluFiyat || '';
        else {
          // Sistem tipi henüz seçilmediyse, en mantıklı varsayılan fiyatı tablodan çek
          priceToSet = product.merdivenIpliFiyat || product.kurdeleliFiyat || product.merdivenIpliReduktorluFiyat || product.kurdelaliReduktorluFiyat || '';
        }
      } else {
        priceToSet = product.unitPrice;
      }

      let extra = 0;
      let extraCost = 0;
      if (selectedProductType === 'tul' || selectedProductType === 'kanat') {
        if (newOrder.pileModel === 'S Pile') {
          extra = getSettingPrice('sPile');
          extraCost = getSettingCost('sPile');
        }
        if (newOrder.pileModel === "Amerikan Pile 2'li") {
          extra = getSettingPrice('american2');
          extraCost = getSettingCost('american2');
        }
        if (newOrder.pileModel === "Amerikan Pile 3'lü") {
          extra = getSettingPrice('american3');
          extraCost = getSettingCost('american3');
        }
        if (newOrder.pileModel === 'Kapsül Pile') {
          const capUnitPrice = getSettingPrice('kapsul');
          onFieldChange('capsuleUnitPrice', capUnitPrice);
          extraCost = getSettingCost('kapsul');
        }
      } else if (selectedProductType === 'ahsapJaluzi') {
        // Ahşap Jaluzi için ek ücretler (varsa) buraya eklenebilir
      } else if (selectedProductType === 'metalJaluzi') {
        if (newOrder.hasMetalReduktor) {
          extra += getSettingPrice('metalReduktor');
          extraCost += getSettingCost('metalReduktor');
        }
      } else if (selectedProductType === 'dikeyPerde') {
        if (newOrder.hasDikeyFon) {
          extra += getSettingPrice('dikeyFon');
          extraCost += getSettingCost('dikeyFon');
        }
      }

      if (selectedProductType === 'katlamaliPerde') {
        onFieldChange('fabricPrice', priceToSet);
      }

      // Maliyet hesaplama
      let costToSet = product.cost || 0;
      if (selectedProductType === 'ahsapJaluzi') {
        const pType = newOrder.sistemTipi;
        if (pType === JALUZI_SISTEM_TIPLERI.merdivenIpli) costToSet = product.merdivenIpliMaliyet || 0;
        else if (pType === JALUZI_SISTEM_TIPLERI.kurdeleli) costToSet = product.kurdeleliMaliyet || 0;
        else if (pType === JALUZI_SISTEM_TIPLERI.merdivenIpliReduktorlu) costToSet = product.merdivenIpliReduktorluMaliyet || 0;
        else if (pType === JALUZI_SISTEM_TIPLERI.kurdelaliReduktorlu) costToSet = product.kurdelaliReduktorluMaliyet || 0;
        else {
          costToSet = product.merdivenIpliMaliyet || product.kurdeleliMaliyet || product.merdivenIpliReduktorluMaliyet || product.kurdelaliReduktorluMaliyet || 0;
        }
      }
      onFieldChange('fabricCost', costToSet);
      onFieldChange('baseUnitCost', costToSet);
      onFieldChange('unitCost', Number(costToSet) + extraCost);

      onFieldChange('unitPrice', Number(priceToSet) + extra);
      onFieldChange('baseUnitPrice', priceToSet);
    } else {
      onFieldChange('productName', '');
      onFieldChange('unitPrice', '');
    }
  };

  const handlePliseProduct1Select = (productId) => {
    const product = productItems.find(p => p.id === productId);
    if (product) {
      onFieldChange('pliseProduct1Name', product.name);
      const priceToSet = isWholesale
        ? (product.wholesalePrice && product.wholesalePrice > 0 ? product.wholesalePrice : product.unitPrice || '')
        : (product.unitPrice || '');
      onFieldChange('pliseProduct1Price', priceToSet);
      onFieldChange('pliseProduct1Cost', product.cost || 0);
    } else {
      onFieldChange('pliseProduct1Name', '');
      onFieldChange('pliseProduct1Price', '');
      onFieldChange('pliseProduct1Cost', 0);
    }
  };

  const handlePliseProduct2Select = (productId) => {
    const product = productItems.find(p => p.id === productId);
    if (product) {
      onFieldChange('pliseProduct2Name', product.name);
      const priceToSet = isWholesale
        ? (product.wholesalePrice && product.wholesalePrice > 0 ? product.wholesalePrice : product.unitPrice || '')
        : (product.unitPrice || '');
      onFieldChange('pliseProduct2Price', priceToSet);
      onFieldChange('pliseProduct2Cost', product.cost || 0);
    } else {
      onFieldChange('pliseProduct2Name', '');
      onFieldChange('pliseProduct2Price', '');
      onFieldChange('pliseProduct2Cost', 0);
    }
  };

  const handleKatlamaliMechanismSelect = (mechanismType) => {
    const mechanism = adminSettings.katlamaliMekanizmaList.find(m => m.type === mechanismType);
    if (mechanism) {
      const wholesalePrice = (mechanism.wholesale !== undefined && mechanism.wholesale !== null && mechanism.wholesale !== 0) ? mechanism.wholesale : mechanism.price;
      const finalPrice = isWholesale ? wholesalePrice : mechanism.price;

      onFieldChange('mechanismType', mechanism.type);
      onFieldChange('mechanismPrice', finalPrice);

      // UnitCost hesabına mekanizma maliyetini ekle
      const baseCost = Number(newOrder.baseUnitCost) || 0;
      const mekCost = Number(mechanism.cost) || 0;
      onFieldChange('unitCost', baseCost + mekCost);
    } else {
      onFieldChange('mechanismType', mechanismType);
      onFieldChange('mechanismPrice', '');

      const baseCost = Number(newOrder.baseUnitCost) || 0;
      onFieldChange('unitCost', baseCost);
    }
  };

  const handleAddAccessory = () => {
    const currentAccessories = Array.isArray(newOrder.accessories) ? newOrder.accessories : [];
    const newAccessories = [...currentAccessories, { id: Date.now().toString(), name: '', price: '', quantity: '1', total: '0' }];
    onFieldChange('accessories', newAccessories);
  };

  const handleRemoveAccessory = (id) => {
    const currentAccessories = Array.isArray(newOrder.accessories) ? newOrder.accessories : [];
    const newAccessories = currentAccessories.filter(acc => acc.id !== id);
    onFieldChange('accessories', newAccessories);
  };

  const handleAccessoryChange = (id, field, value) => {
    const currentAccessories = Array.isArray(newOrder.accessories) ? newOrder.accessories : [];
    const newAccessories = currentAccessories.map(acc => {
      if (acc.id === id) {
        const updatedAcc = { ...acc, [field]: value };
        if (field === 'price' || field === 'quantity') {
          const p = parseFloat(updatedAcc.price) || 0;
          const q = parseFloat(updatedAcc.quantity) || 0;
          updatedAcc.total = (p * q).toFixed(2);
        }
        return updatedAcc;
      }
      return acc;
    });
    onFieldChange('accessories', newAccessories);
  };

  // Ürün için unique key oluştur
  const createProductKey = useCallback(() => {
    const { roomName, productName, productType } = newOrder;
    if (!roomName || !productName || !productType) return 'temp';

    // Oda + Ürün Adı + Ürün Tipi kombinasyonu ile unique key
    return `${productType} -${roomName} -${productName} `.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
  }, [newOrder]);

  // Component mount olduğunda ve ürün bilgileri değiştiğinde localStorage'dan verileri yükle
  useEffect(() => {
    if (customerId && !customerId.startsWith('temp_')) {
      // Ürün bazında unique key oluştur
      const productKey = createProductKey();
      if (productKey !== 'temp') {
        const savedData = localStorage.getItem(`whatsapp - ${customerId} -${productKey} `);
        if (savedData) {
          try {
            const { selectedFirmaId, lastSentFirmaInfo } = JSON.parse(savedData);
            setSelectedFirma(selectedFirmaId || '');
            setLastSentFirma(lastSentFirmaInfo || null);
          } catch (error) {
            console.error('WhatsApp verileri yüklenirken hata:', error);
          }
        } else {
          // Bu ürün için kayıtlı veri yoksa sıfırla
          setSelectedFirma('');
          setLastSentFirma(null);
        }
      }
    }
  }, [customerId, createProductKey]);

  // WhatsApp gönderme fonksiyonu
  const handleWhatsAppSend = () => {
    if (!selectedFirma) {
      alert('Lütfen firma seçin!');
      return;
    }

    if (!customerInfo || !newOrder || !selectedProductType) {
      alert('Müşteri bilgileri veya sipariş bulunamadı!');
      return;
    }

    // Firestore'dan gelen firmaları kullan, yoksa constants'taki listeyi kullan
    const selectedFirmaInfo = companies.find(firma => firma.id === selectedFirma);
    if (selectedFirmaInfo) {
      // newOrder'a productType ekleyerek gönder
      const orderWithType = { ...newOrder, productType: selectedProductType };
      sendSingleOrderWhatsAppMessage(customerInfo, orderWithType, selectedFirmaInfo);

      // Son gönderilen firmayı kaydet
      setLastSentFirma(selectedFirmaInfo);

      // localStorage'a ürün bazında kaydet
      if (customerId && !customerId.startsWith('temp_')) {
        const productKey = createProductKey();
        const dataToSave = {
          selectedFirmaId: selectedFirma,
          lastSentFirmaInfo: selectedFirmaInfo
        };
        localStorage.setItem(`whatsapp - ${customerId} -${productKey} `, JSON.stringify(dataToSave));
      }
    }
  };

  // Katlamalı Perde için çoklu WhatsApp gönderme fonksiyonu
  const handleKatlamaliWhatsAppSend = (subType) => {
    let firmaId = '';
    if (subType === 'kumas') firmaId = selectedFirmaKumas;
    else if (subType === 'mekanizma') firmaId = selectedFirmaMekanizma;
    else if (subType === 'motor') firmaId = selectedFirmaMotor;
    else if (subType === 'aksesuar') firmaId = selectedFirmaAksesuar;

    if (!firmaId) {
      alert('Lütfen firma seçin!');
      return;
    }

    if (!customerInfo || !newOrder || !selectedProductType) {
      alert('Müşteri bilgileri veya sipariş bulunamadı!');
      return;
    }

    const selectedFirmaInfo = companies.find(firma => firma.id === firmaId);
    if (selectedFirmaInfo) {
      const orderWithType = { ...newOrder, productType: selectedProductType };
      sendSingleOrderWhatsAppMessage(customerInfo, orderWithType, selectedFirmaInfo, subType);

      // Son gönderilene kaydet
      if (subType === 'kumas') setLastSentFirmaKumas(selectedFirmaInfo);
      else if (subType === 'mekanizma') setLastSentFirmaMekanizma(selectedFirmaInfo);
      else if (subType === 'motor') setLastSentFirmaMotor(selectedFirmaInfo);
      else if (subType === 'aksesuar') setLastSentFirmaAksesuar(selectedFirmaInfo);
    }
  };

  // react-select için stil özelleştirmesi
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      padding: '0px 4px',
      minHeight: '42px',
      border: state.isFocused ? '1px solid #b04309' : '1px solid #ddd',
      boxShadow: 'none',
      borderRadius: '6px',
      '&:hover': {
        border: state.isFocused ? '1px solid #b04309' : '1px solid #cbd5e1'
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 8px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '42px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px',
      padding: '0px',
      'input:focus': {
        boxShadow: 'none !important'
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#b04309' : state.isFocused ? '#fff5f0' : 'white',
      color: state.isSelected ? 'white' : '#333',
      cursor: 'pointer',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#333',
    })
  };

  // Ürün dropdown için ortak options objesi oluşturma
  const productOptions = productItems.map(p => ({ value: p.id, label: p.name }));

  return (
    <div className="order-form">
      <h5>{editingOrderId ? 'Sipariş Düzenle' : 'Yeni Sipariş Ekle'}</h5>
      <form onSubmit={onSubmit}>
        {/* Ürün Tipi Seçimi */}
        <div className="form-group">
          <label>Ürün Tipi *</label>
          <select
            value={selectedProductType}
            onChange={(e) => onProductTypeChange(e.target.value)}
            required
            disabled={isLoading}
          >
            <option value="">Ürün tipi seçin</option>
            {Object.entries(PRODUCT_TYPES).map(([key, product]) => (
              <option key={key} value={key}>{product.label}</option>
            ))}
          </select>
        </div>

        {selectedProductType && (
          <div className="dynamic-fields">
            {/* Tül ve Kanat için özel alanlar */}
            {(selectedProductType === 'tul' || selectedProductType === 'kanat') && (
              <>
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input
                      type="text"
                      value={newOrder.roomName}
                      onChange={(e) => onFieldChange('roomName', e.target.value)}
                      disabled={isLoading}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
                      (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('productName', '');
                        onFieldChange('unitPrice', '');
                      } else if (option.__isNew__) {
                        onFieldChange('productName', option.value);
                        onFieldChange('unitPrice', '');
                      } else {
                        handleProductSelect(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>

                <div className="form-group">
                  <label>Ürün Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.productVariant || ''}
                    onChange={(e) => onFieldChange('productVariant', e.target.value)}
                    disabled={isLoading}
                    placeholder="Renk, desen vb. giriniz..."
                  />
                </div>

                <div className="form-group">
                  <label>{isWholesale ? 'En (m) *' : 'En (cm) *'}</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.width}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('width', e.target.value)}
                    required
                    disabled={isLoading}
                    placeholder={isWholesale ? 'Metre cinsinden giriniz' : ''}
                  />
                </div>

                {!isWholesale && (
                  <div className="form-group">
                    <label>Boy (cm) *</label>
                    <input
                      type="number"
                      step="0.01"
                      value={newOrder.height}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('height', e.target.value)}
                      required
                      disabled={isLoading}
                    />
                  </div>
                )}

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Birim Fiyat (₺) *</label>
                    <button
                      type="button"
                      className={`lock-btn ${showBaseCost ? 'active' : ''}`}
                      onClick={() => setShowBaseCost(!showBaseCost)}
                      title="Maliyet Bilgisi"
                    >
                      <i className={`fas ${showBaseCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    min="0.01"
                    value={newOrder.unitPrice}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => {
                      onFieldChange('unitPrice', e.target.value);
                      onFieldChange('baseUnitPrice', e.target.value); // Custom override resets baseline
                    }}
                    required
                    disabled={isLoading}
                  />
                </div>

                {showBaseCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Ürün Maliyeti (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={newOrder.baseUnitCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('baseUnitCost', e.target.value)}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                {!isWholesale && (
                  <>
                    <div className="form-group">
                      <label>Pile Modeli *</label>
                      <select
                        value={newOrder.pileModel || ''}
                        onChange={(e) => {
                          const selectedModel = e.target.value;
                          onFieldChange('pileModel', selectedModel);

                          if ((selectedProductType === 'tul' || selectedProductType === 'kanat') && newOrder.baseUnitPrice !== undefined) {
                            let extra = 0;
                            let extraCost = 0;
                            if (selectedModel === 'S Pile') {
                              extra = getSettingPrice('sPile');
                              extraCost = getSettingCost('sPile');
                            }
                            if (selectedModel === "Amerikan Pile 2'li") {
                              extra = getSettingPrice('american2');
                              extraCost = getSettingCost('american2');
                            }
                            if (selectedModel === "Amerikan Pile 3'lü") {
                              extra = getSettingPrice('american3');
                              extraCost = getSettingCost('american3');
                            }
                            if (selectedModel === 'Kapsül Pile') {
                              const capUnitPrice = getSettingPrice('kapsul');
                              onFieldChange('capsuleUnitPrice', capUnitPrice);
                              extraCost = getSettingCost('kapsul');
                            }
                            onFieldChange('unitPrice', (Number(newOrder.baseUnitPrice) || 0) + extra);
                            onFieldChange('unitCost', (Number(newOrder.baseUnitCost) || 0) + extraCost);
                          }
                        }}
                        required
                        disabled={isLoading}
                      >
                        <option value="">Pile modeli seçin</option>
                        {localPileModels.map((model) => (
                          <option key={model.id} value={model.modelName}>
                            {model.modelName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {newOrder.pileModel && (
                      <div className="form-group">
                        <label>Pile Sıklığı</label>
                        <input
                          type="number"
                          step="0.1"
                          min="0.1"
                          value={newOrder.pileDensity || ''}
                          onChange={(e) => onFieldChange('pileDensity', e.target.value)}
                          disabled={isLoading}
                          placeholder="Pile sıklığı"
                        />
                        <small>Pile sıklığını düzenleyebilirsiniz</small>
                      </div>
                    )}

                    {newOrder.usedM2 && (
                      <div className="form-group">
                        <label>Kullanılan Mt</label>
                        <input
                          type="text"
                          value={newOrder.usedM2}
                          readOnly
                          className="readonly-field"
                        />
                      </div>
                    )}

                    <div className="form-group">
                      <div className="label-with-icon">
                        <label>Ek Ücret (₺)</label>
                        <button
                          type="button"
                          className={`lock-btn ${showExtraCost ? 'active' : ''}`}
                          onClick={() => setShowExtraCost(!showExtraCost)}
                          title="Ek Maliyet Girişi"
                        >
                          <i className={`fas ${showExtraCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                        </button>
                      </div>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        value={newOrder.extraPrice}
                        onKeyDown={handleNumericKeyDown}
                        onChange={(e) => {
                          onFieldChange('extraPrice', e.target.value);
                          onFieldChange('manualExtraCost', '');
                        }}
                        disabled={isLoading}
                      />
                    </div>

                    {showExtraCost && (
                      <div className="form-group">
                        <label className="extra-cost-label">Ek Ücret Maliyeti (₺)</label>
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          value={newOrder.manualExtraCost || ''}
                          onKeyDown={handleNumericKeyDown}
                          onChange={(e) => onFieldChange('manualExtraCost', e.target.value)}
                          disabled={isLoading}
                          placeholder="Gizli maliyet"
                        />
                      </div>
                    )}

                    {newOrder.pileModel === 'Kapsül Pile' && (
                      <>
                        <div className="form-group">
                          <label>Kapsül Birim Fiyat (₺) *</label>
                          <input
                            type="number"
                            step="0.01"
                            value={newOrder.capsuleUnitPrice}
                            onChange={(e) => onFieldChange('capsuleUnitPrice', e.target.value)}
                            required
                            disabled={isLoading}
                          />
                        </div>

                        {newOrder.capsulePrice && (
                          <div className="form-group">
                            <label>Kapsül Ücreti (₺)</label>
                            <input
                              type="text"
                              value={formatPrice(newOrder.capsulePrice)}
                              readOnly
                              className="readonly-field"
                            />
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}

                <div className="form-group">
                  <label>Adet *</label>
                  <input
                    type="number"
                    step="1"
                    min="1"
                    value={newOrder.quantity || ''}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('quantity', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    value={newOrder.discount}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('discount', e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.totalPrice)}
                      readOnly
                      className="total-price"
                    />
                  </div>
                )}

                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.discountedPrice)}
                      readOnly
                      className="discounted-price"
                    />
                  </div>
                )}
              </>
            )}

            {/* Stor ve Zebra için özel alanlar */}
            {(selectedProductType === 'stor' || selectedProductType === 'zebra') && (
              <>
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input
                      type="text"
                      value={newOrder.roomName}
                      onChange={(e) => onFieldChange('roomName', e.target.value)}
                      disabled={isLoading}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
                      (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('productName', '');
                        onFieldChange('unitPrice', '');
                      } else if (option.__isNew__) {
                        onFieldChange('productName', option.value);
                        onFieldChange('unitPrice', '');
                      } else {
                        handleProductSelect(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>

                <div className="form-group">
                  <label>Ürün Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.productVariant || ''}
                    onChange={(e) => onFieldChange('productVariant', e.target.value)}
                    disabled={isLoading}
                    placeholder="Renk, desen vb. giriniz..."
                  />
                </div>

                <div className="form-group">
                  <label>En (cm) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.width}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('width', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>Boy (cm) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.height}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('height', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>Yön *</label>
                  <select
                    value={newOrder.direction || ''}
                    onChange={(e) => onFieldChange('direction', e.target.value)}
                    required
                    disabled={isLoading}
                  >
                    <option value="">Seçiniz</option>
                    {Object.entries(DIRECTION_TYPES).map(([key, value]) => (
                      <option key={key} value={value}>{value}</option>
                    ))}
                  </select>
                </div>

                {newOrder.usedM2 && (
                  <div className="form-group">
                    <label>Kullanılan Mt²</label>
                    <input
                      type="text"
                      value={newOrder.usedM2}
                      readOnly
                      className="readonly-field"
                    />
                  </div>
                )}

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Birim Fiyat (₺) *</label>
                    <button
                      type="button"
                      className={`lock-btn ${showBaseCost ? 'active' : ''}`}
                      onClick={() => setShowBaseCost(!showBaseCost)}
                      title="Maliyet Bilgisi"
                    >
                      <i className={`fas ${showBaseCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    min="0.01"
                    value={newOrder.unitPrice}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => {
                      onFieldChange('unitPrice', e.target.value);
                      onFieldChange('baseUnitCost', '');
                    }}
                    required
                    disabled={isLoading}
                  />
                </div>

                {showBaseCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Birim Maliyet (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={newOrder.baseUnitCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('baseUnitCost', e.target.value)}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}


                {(selectedProductType === 'stor' || selectedProductType === 'zebra') && (
                  <>
                    <div className="form-group">
                      <label>Motor</label>
                      <select
                        value={newOrder.motorType || ''}
                        onChange={(e) => onFieldChange('motorType', e.target.value)}
                        disabled={isLoading}
                      >
                        <option value="">Seçiniz</option>
                        {Object.entries(MOTOR_TYPES).map(([key, value]) => (
                          <option key={key} value={value}>{value}</option>
                        ))}
                      </select>
                    </div>

                    {newOrder.motorType && (
                      <div className="form-group">
                        <label>Motor Ücreti ({getMotorCurrency()})</label>
                        <input
                          type="number"
                          step="0.01"
                          value={newOrder.motorPriceCurrency || ''}
                          onChange={(e) => onFieldChange('motorPriceCurrency', e.target.value)}
                          disabled={isLoading}
                        />
                        {newOrder.motorPriceCurrency && (
                          <small style={{ display: 'block', marginTop: '5px', color: '#b04309' }}>
                            ≈ {newOrder.motorPrice ? Number(newOrder.motorPrice).toFixed(2) : 0} ₺
                          </small>
                        )}
                      </div>
                    )}
                  </>
                )}

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Montaj (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn ${showMountingCost ? 'active' : ''}`}
                      onClick={() => setShowMountingCost(!showMountingCost)}
                      title="Montaj Maliyet Girişi"
                    >
                      <i className={`fas ${showMountingCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.mounting || ''}
                    onChange={(e) => onFieldChange('mounting', e.target.value)}
                    disabled={isLoading}
                  />
                </div>
                {showMountingCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Montaj Maliyeti (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={newOrder.mountingCost || ''}
                      onChange={(e) => onFieldChange('mountingCost', e.target.value)}
                      onKeyDown={handleNumericKeyDown}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Adet *</label>
                  <input
                    type="number"
                    step="1"
                    min="1"
                    value={newOrder.quantity || ''}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('quantity', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    value={newOrder.discount}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('discount', e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                <div style={{ gridColumn: '1 / -1', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px', marginTop: '15px', marginBottom: '15px' }}>
                  {selectedProductType === 'stor' && (
                    <>
                      <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
                        <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                          <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorJumbo || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorJumbo', checked); onFieldChange('storJumboAmount', checked ? getSettingPrice('storJumbo') : 0); }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Jumbo Sistem</span>
                            <small style={{ color: '#b04309', fontSize: '11px' }}>{getSettingPrice('storJumbo')} ₺</small>
                          </div>
                        </label>
                      </div>
                      <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
                        <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                          <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorAltEtekDilim || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorAltEtekDilim', checked); onFieldChange('storAltEtekDilimAmount', checked ? getSettingPrice('storAltEtekDilim') : 0); }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Alt Etek Dilim</span>
                            <small style={{ color: '#b04309', fontSize: '11px' }}>{getSettingPrice('storAltEtekDilim')} ₺</small>
                          </div>
                        </label>
                      </div>
                      <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
                        <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                          <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorKapaliKasa || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorKapaliKasa', checked); onFieldChange('storKapaliKasaAmount', checked ? getSettingPrice('storKapaliKasa') : 0); }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Kapalı Kasa</span>
                            <small style={{ color: '#b04309', fontSize: '11px' }}>{getSettingPrice('storKapaliKasa')} ₺</small>
                          </div>
                        </label>
                      </div>
                      <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
                        <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                          <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorAltEtekLazer || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorAltEtekLazer', checked); onFieldChange('storAltEtekLazerAmount', checked ? getSettingPrice('storAltEtekLazer') : 0); }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Alt Etek Lazer</span>
                            <small style={{ color: '#b04309', fontSize: '11px' }}>{getSettingPrice('storAltEtekLazer')} ₺</small>
                          </div>
                        </label>
                      </div>
                      <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
                        <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                          <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorDekoratifLama || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorDekoratifLama', checked); onFieldChange('storDekoratifLamaAmount', checked ? getSettingPrice('storDekoratifLama') : 0); }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Dekoratif Lama</span>
                            <small style={{ color: '#b04309', fontSize: '11px' }}>{getSettingPrice('storDekoratifLama')} ₺</small>
                          </div>
                        </label>
                      </div>
                      <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
                        <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                          <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorDekoratifKasa || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorDekoratifKasa', checked); onFieldChange('storDekoratifKasaAmount', checked ? getSettingPrice('storDekoratifKasa') : 0); }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Dekoratif Kasa</span>
                            <small style={{ color: '#b04309', fontSize: '11px' }}>{getSettingPrice('storDekoratifKasa')} ₺</small>
                          </div>
                        </label>
                      </div>
                      <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
                        <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                          <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorAltEtekBeyazIs || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorAltEtekBeyazIs', checked); onFieldChange('storAltEtekBeyazIsAmount', checked ? getSettingPrice('storAltEtekBeyazIs') : 0); }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Alt Etek Beyaz İş</span>
                            <small style={{ color: '#b04309', fontSize: '11px' }}>{getSettingPrice('storAltEtekBeyazIs')} ₺</small>
                          </div>
                        </label>
                      </div>
                    </>
                  )}

                  {selectedProductType === 'zebra' && (
                    <>
                      <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
                        <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                          <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasZebraJumbo || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasZebraJumbo', checked); onFieldChange('zebraJumboAmount', checked ? getSettingPrice('zebraJumbo') : 0); }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Jumbo Sistem (Zebra)</span>
                            <small style={{ color: '#b04309', fontSize: '11px' }}>{getSettingPrice('zebraJumbo')} ₺</small>
                          </div>
                        </label>
                      </div>
                      <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
                        <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                          <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasZebraAltEtekDilim || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasZebraAltEtekDilim', checked); onFieldChange('zebraAltEtekDilimAmount', checked ? getSettingPrice('zebraAltEtekDilim') : 0); }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Alt Etek Dilim (Zebra)</span>
                            <small style={{ color: '#b04309', fontSize: '11px' }}>{getSettingPrice('zebraAltEtekDilim')} ₺</small>
                          </div>
                        </label>
                      </div>
                      <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
                        <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                          <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasZebraKapaliKasa || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasZebraKapaliKasa', checked); onFieldChange('zebraKapaliKasaAmount', checked ? getSettingPrice('zebraKapaliKasa') : 0); }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Kapalı Kasa (Zebra)</span>
                            <small style={{ color: '#b04309', fontSize: '11px' }}>{getSettingPrice('zebraKapaliKasa')} ₺</small>
                          </div>
                        </label>
                      </div>
                    </>
                  )}
                </div>


                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.totalPrice)}
                      readOnly
                      className="total-price"
                    />
                  </div>
                )}

                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.discountedPrice)}
                      readOnly
                      className="discounted-price"
                    />
                  </div>
                )}
              </>
            )}

            {/* Ahşap Jaluzi için özel alanlar */}
            {selectedProductType === 'ahsapJaluzi' && (
              <>
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input type="text" value={newOrder.roomName} onChange={(e) => onFieldChange('roomName', e.target.value)} disabled={isLoading} />
                  </div>
                )}
                <div className="form-group">
                  <label>Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
                      (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('productName', '');
                        onFieldChange('unitPrice', '');
                      } else if (option.__isNew__) {
                        onFieldChange('productName', option.value);
                        onFieldChange('unitPrice', '');
                      } else {
                        handleProductSelect(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>
                <div className="form-group">
                  <label>Ürün Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.productVariant || ''}
                    onChange={(e) => onFieldChange('productVariant', e.target.value)}
                    disabled={isLoading}
                    placeholder="Renk, desen vb. giriniz..."
                  />
                </div>
                <div className="form-group">
                  <label>Sistem Tipi *</label>
                  <Select
                    options={Object.entries(JALUZI_SISTEM_TIPLERI).map(([key, value]) => ({ value: value, label: value }))}
                    value={newOrder.sistemTipi ? { value: newOrder.sistemTipi, label: newOrder.sistemTipi } : null}
                    onChange={(option) => {
                      const selectedSys = option ? option.value : '';
                      onFieldChange('sistemTipi', selectedSys);
                      const currentProduct = productItems.find(p => p.name === newOrder.productName);
                      let newPrice = newOrder.unitPrice;
                      let newCost = newOrder.unitCost;
                      if (currentProduct) {
                        if (selectedSys === JALUZI_SISTEM_TIPLERI.merdivenIpli) {
                          newPrice = currentProduct.merdivenIpliFiyat || '';
                          newCost = currentProduct.merdivenIpliMaliyet || '';
                        } else if (selectedSys === JALUZI_SISTEM_TIPLERI.kurdeleli) {
                          newPrice = currentProduct.kurdeleliFiyat || '';
                          newCost = currentProduct.kurdeleliMaliyet || '';
                        } else if (selectedSys === JALUZI_SISTEM_TIPLERI.merdivenIpliReduktorlu) {
                          newPrice = currentProduct.merdivenIpliReduktorluFiyat || '';
                          newCost = currentProduct.merdivenIpliReduktorluMaliyet || '';
                        } else if (selectedSys === JALUZI_SISTEM_TIPLERI.kurdelaliReduktorlu) {
                          newPrice = currentProduct.kurdelaliReduktorluFiyat || '';
                          newCost = currentProduct.kurdelaliReduktorluMaliyet || '';
                        } else {
                          newPrice = currentProduct.merdivenIpliFiyat || currentProduct.kurdeleliFiyat || currentProduct.merdivenIpliReduktorluFiyat || currentProduct.kurdelaliReduktorluFiyat || '';
                          newCost = currentProduct.merdivenIpliMaliyet || currentProduct.kurdeleliMaliyet || currentProduct.merdivenIpliReduktorluMaliyet || currentProduct.kurdelaliReduktorluMaliyet || 0;
                        }

                        onFieldChange('baseUnitPrice', newPrice);
                        onFieldChange('unitPrice', newPrice);
                        onFieldChange('baseUnitCost', newCost);
                        onFieldChange('unitCost', newCost);
                      }
                    }}
                    isDisabled={isLoading} isClearable isSearchable placeholder="Sistem Tipi Seçin" noOptionsMessage={() => "Sistem Tipi bulunamadı"} filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())} styles={customSelectStyles}
                  />
                </div>
                <div className="form-group">
                  <label>En (cm) *</label>
                  <input type="number" step="0.01" onKeyDown={handleNumericKeyDown} value={newOrder.width} onChange={(e) => onFieldChange('width', e.target.value)} required disabled={isLoading} />
                </div>
                <div className="form-group">
                  <label>Boy (cm) *</label>
                  <input type="number" step="0.01" onKeyDown={handleNumericKeyDown} value={newOrder.height} onChange={(e) => onFieldChange('height', e.target.value)} required disabled={isLoading} />
                </div>
                {newOrder.usedM2 && (
                  <div className="form-group">
                    <label>Kullanılan Mt²</label>
                    <input type="text" value={newOrder.usedM2} readOnly className="readonly-field" />
                  </div>
                )}
                <div className="form-group">
                  <label>Yön *</label>
                  <select value={newOrder.direction || ''} onChange={(e) => onFieldChange('direction', e.target.value)} required disabled={isLoading}>
                    <option value="">Seçiniz</option>
                    {Object.entries(DIRECTION_TYPES).map(([key, value]) => (<option key={key} value={value}>{value}</option>))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Motor</label>
                  <select value={newOrder.motorType || ''} onChange={(e) => onFieldChange('motorType', e.target.value)} disabled={isLoading}>
                    <option value="">Seçiniz</option>
                    {Object.entries(MOTOR_TYPES).map(([key, value]) => (<option key={key} value={value}>{value}</option>))}
                  </select>
                </div>
                {newOrder.motorType && (
                  <div className="form-group">
                    <label>Motor Ücreti ({getMotorCurrency()})</label>
                    <input type="number" step="0.01" value={newOrder.motorPriceCurrency || ''} onChange={(e) => onFieldChange('motorPriceCurrency', e.target.value)} disabled={isLoading} />
                    {newOrder.motorPriceCurrency && <small style={{ display: 'block', marginTop: '5px', color: '#b04309' }}>≈ {newOrder.motorPrice ? Number(newOrder.motorPrice).toFixed(2) : 0} ₺</small>}
                  </div>
                )}
                <div className="form-group">
                  <label>&nbsp;</label>
                  <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }} onMouseOver={(e) => { e.currentTarget.style.borderColor = '#94a3b8'; e.currentTarget.style.backgroundColor = '#f1f5f9' }} onMouseOut={(e) => { e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.backgroundColor = '#f8fafc' }}>
                    <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasZigil || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasZigil', checked); onFieldChange('zigilAmount', checked ? getSettingPrice('zigil') : 0); }} />
                    <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Ahşap Zıgıl Sistemi</span>
                  </label>
                </div>
                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Birim Fiyat (₺) *</label>
                    <button type="button" className={`lock-btn ${showBaseCost ? 'active' : ''}`} onClick={() => setShowBaseCost(!showBaseCost)} title="Maliyet Bilgisi"><i className={`fas ${showBaseCost ? 'fa-lock-open' : 'fa-lock'}`}></i></button>
                  </div>
                  <input type="number" step="0.01" min="0.01" onKeyDown={handleNumericKeyDown} value={newOrder.unitPrice} onChange={(e) => { onFieldChange('unitPrice', e.target.value); onFieldChange('baseUnitPrice', e.target.value); onFieldChange('baseUnitCost', ''); onFieldChange('unitCost', ''); }} required disabled={isLoading} />
                </div>
                {showBaseCost && (<div className="form-group"><label className="extra-cost-label">Birim Maliyet (₺)</label><input type="number" step="0.01" min="0" value={newOrder.unitCost || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => { onFieldChange('unitCost', e.target.value); onFieldChange('baseUnitCost', e.target.value); }} disabled={isLoading} placeholder="Gizli maliyet" /></div>)}
                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Montaj (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn ${showMountingCost ? 'active' : ''}`}
                      onClick={() => setShowMountingCost(!showMountingCost)}
                      title="Montaj Maliyet Girişi"
                    >
                      <i className={`fas ${showMountingCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input type="number" step="0.01" value={newOrder.mounting} onChange={(e) => onFieldChange('mounting', e.target.value)} disabled={isLoading} />
                </div>
                {showMountingCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Montaj Maliyeti (₺)</label>
                    <input type="number" step="0.01" value={newOrder.mountingCost || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('mountingCost', e.target.value)} disabled={isLoading} placeholder="Gizli maliyet" />
                  </div>
                )}

                <div className="form-group">
                  <label>Adet *</label>
                  <input type="number" step="1" min="1" onKeyDown={handleNumericKeyDown} value={newOrder.quantity || ''} onChange={(e) => onFieldChange('quantity', e.target.value)} required disabled={isLoading} />
                </div>
                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input type="number" step="0.01" min="0" max="100" onKeyDown={handleNumericKeyDown} value={newOrder.discount} onChange={(e) => onFieldChange('discount', e.target.value)} disabled={isLoading} />
                </div>
                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input type="text" value={formatPrice(newOrder.totalPrice)} readOnly className="total-price" />
                  </div>
                )}
                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input type="text" value={formatPrice(newOrder.discountedPrice)} readOnly className="discounted-price" />
                  </div>
                )}
              </>
            )}

            {/* Metal Jaluzi için özel alanlar */}
            {selectedProductType === 'metalJaluzi' && (
              <>
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input type="text" value={newOrder.roomName} onChange={(e) => onFieldChange('roomName', e.target.value)} disabled={isLoading} />
                  </div>
                )}
                <div className="form-group">
                  <label>Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
                      (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('productName', '');
                        onFieldChange('unitPrice', '');
                      } else if (option.__isNew__) {
                        onFieldChange('productName', option.value);
                        onFieldChange('unitPrice', '');
                      } else {
                        handleProductSelect(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>
                <div className="form-group">
                  <label>Ürün Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.productVariant || ''}
                    onChange={(e) => onFieldChange('productVariant', e.target.value)}
                    disabled={isLoading}
                    placeholder="Renk, desen vb. giriniz..."
                  />
                </div>
                <div className="form-group">
                  <label>En (cm) *</label>
                  <input type="number" step="0.01" onKeyDown={handleNumericKeyDown} value={newOrder.width} onChange={(e) => onFieldChange('width', e.target.value)} required disabled={isLoading} />
                </div>
                <div className="form-group">
                  <label>Boy (cm) *</label>
                  <input type="number" step="0.01" onKeyDown={handleNumericKeyDown} value={newOrder.height} onChange={(e) => onFieldChange('height', e.target.value)} required disabled={isLoading} />
                </div>
                {newOrder.usedM2 && (
                  <div className="form-group">
                    <label>Kullanılan Mt²</label>
                    <input type="text" value={newOrder.usedM2} readOnly className="readonly-field" />
                  </div>
                )}
                <div className="form-group">
                  <label>Yön *</label>
                  <select value={newOrder.direction || ''} onChange={(e) => onFieldChange('direction', e.target.value)} required disabled={isLoading}>
                    <option value="">Seçiniz</option>
                    {Object.entries(DIRECTION_TYPES).map(([key, value]) => (<option key={key} value={value}>{value}</option>))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Motor</label>
                  <select value={newOrder.motorType || ''} onChange={(e) => onFieldChange('motorType', e.target.value)} disabled={isLoading}>
                    <option value="">Seçiniz</option>
                    {Object.entries(MOTOR_TYPES).map(([key, value]) => (<option key={key} value={value}>{value}</option>))}
                  </select>
                </div>
                {newOrder.motorType && (
                  <div className="form-group">
                    <label>Motor Ücreti ({getMotorCurrency()})</label>
                    <input type="number" step="0.01" value={newOrder.motorPriceCurrency || ''} onChange={(e) => onFieldChange('motorPriceCurrency', e.target.value)} disabled={isLoading} />
                    {newOrder.motorPriceCurrency && <small style={{ display: 'block', marginTop: '5px', color: '#b04309' }}>≈ {newOrder.motorPrice ? Number(newOrder.motorPrice).toFixed(2) : 0} ₺</small>}
                  </div>
                )}
                <div className="form-group">
                  <label>&nbsp;</label>
                  <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }} onMouseOver={(e) => { e.currentTarget.style.borderColor = '#94a3b8'; e.currentTarget.style.backgroundColor = '#f1f5f9' }} onMouseOut={(e) => { e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.backgroundColor = '#f8fafc' }}>
                    <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasMetalZigil || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasMetalZigil', checked); onFieldChange('metalZigilAmount', checked ? getSettingPrice('metalZigil') : 0); }} />
                    <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Zıgıl Sistem Telli Takım</span>
                  </label>
                </div>
                <div className="form-group">
                  <label>&nbsp;</label>
                  <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }} onMouseOver={(e) => { e.currentTarget.style.borderColor = '#94a3b8'; e.currentTarget.style.backgroundColor = '#f1f5f9' }} onMouseOut={(e) => { e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.backgroundColor = '#f8fafc' }}>
                    <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasMetalReduktor || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasMetalReduktor', checked); const baseP = Number(newOrder.baseUnitPrice) || 0; const baseC = Number(newOrder.baseUnitCost) || 0; const extraRedP = checked ? Number(getSettingPrice('metalReduktor')) : 0; const extraRedC = checked ? Number(getSettingCost('metalReduktor')) : 0; onFieldChange('unitPrice', baseP + extraRedP); onFieldChange('unitCost', baseC + extraRedC); }} />
                    <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Redüktörlü Perde Farkı (m2)</span>
                  </label>
                </div>
                <div className="form-group">
                  <label>&nbsp;</label>
                  <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }} onMouseOver={(e) => { e.currentTarget.style.borderColor = '#94a3b8'; e.currentTarget.style.backgroundColor = '#f1f5f9' }} onMouseOut={(e) => { e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.backgroundColor = '#f8fafc' }}>
                    <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasIkiCamArasi || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasIkiCamArasi', checked); onFieldChange('ikiCamArasiAmount', checked ? getSettingPrice('ikiCamArasi') : 0); }} />
                    <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>İki Cam Arası Buton Sistem Takım</span>
                  </label>
                </div>
                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Birim Fiyat (₺) *</label>
                    <button type="button" className={`lock-btn ${showBaseCost ? 'active' : ''}`} onClick={() => setShowBaseCost(!showBaseCost)} title="Maliyet Bilgisi"><i className={`fas ${showBaseCost ? 'fa-lock-open' : 'fa-lock'}`}></i></button>
                  </div>
                  <input type="number" step="0.01" min="0.01" onKeyDown={handleNumericKeyDown} value={newOrder.unitPrice} onChange={(e) => {
                    onFieldChange('unitPrice', e.target.value);
                    onFieldChange('baseUnitPrice', e.target.value);
                    onFieldChange('baseUnitCost', '');
                    onFieldChange('unitCost', '');
                    if (newOrder.hasMetalReduktor) onFieldChange('hasMetalReduktor', false);
                  }} required disabled={isLoading} />
                </div>
                {showBaseCost && (<div className="form-group"><label className="extra-cost-label">Birim Maliyet (₺)</label><input type="number" step="0.01" min="0" value={newOrder.unitCost || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => {
                  onFieldChange('unitCost', e.target.value);
                  onFieldChange('baseUnitCost', e.target.value);
                  if (newOrder.hasMetalReduktor) {
                    onFieldChange('hasMetalReduktor', false);
                    onFieldChange('unitPrice', newOrder.baseUnitPrice);
                  }
                }} disabled={isLoading} placeholder="Gizli maliyet" /></div>)}
                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Montaj (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn ${showMountingCost ? 'active' : ''}`}
                      onClick={() => setShowMountingCost(!showMountingCost)}
                      title="Montaj Maliyet Girişi"
                    >
                      <i className={`fas ${showMountingCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input type="number" step="0.01" value={newOrder.mounting} onChange={(e) => onFieldChange('mounting', e.target.value)} disabled={isLoading} />
                </div>
                {showMountingCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Montaj Maliyeti (₺)</label>
                    <input type="number" step="0.01" value={newOrder.mountingCost || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('mountingCost', e.target.value)} disabled={isLoading} placeholder="Gizli maliyet" />
                  </div>
                )}
                <div className="form-group">
                  <label>Adet *</label>
                  <input type="number" step="1" min="1" onKeyDown={handleNumericKeyDown} value={newOrder.quantity || ''} onChange={(e) => onFieldChange('quantity', e.target.value)} required disabled={isLoading} />
                </div>
                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input type="number" step="0.01" min="0" max="100" onKeyDown={handleNumericKeyDown} value={newOrder.discount} onChange={(e) => onFieldChange('discount', e.target.value)} disabled={isLoading} />
                </div>
                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input type="text" value={formatPrice(newOrder.totalPrice)} readOnly className="total-price" />
                  </div>
                )}
                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input type="text" value={formatPrice(newOrder.discountedPrice)} readOnly className="discounted-price" />
                  </div>
                )}
              </>
            )}

            {/* Dikey PVC ve Dikey Stor için özel alanlar */}
            {(selectedProductType === 'dikeyPvc' || selectedProductType === 'dikeyStor') && (
              <>
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input
                      type="text"
                      value={newOrder.roomName}
                      onChange={(e) => onFieldChange('roomName', e.target.value)}
                      disabled={isLoading}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
                      (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('productName', '');
                        onFieldChange('unitPrice', '');
                      } else if (option.__isNew__) {
                        onFieldChange('productName', option.value);
                        onFieldChange('unitPrice', '');
                      } else {
                        handleProductSelect(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>

                <div className="form-group">
                  <label>Ürün Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.productVariant || ''}
                    onChange={(e) => onFieldChange('productVariant', e.target.value)}
                    disabled={isLoading}
                    placeholder="Ürün varyantı"
                  />
                </div>

                <div className="form-group">
                  <label>En (cm) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.width}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('width', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>Boy (cm) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.height}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('height', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>Yön *</label>
                  <select
                    value={newOrder.direction || ''}
                    onChange={(e) => onFieldChange('direction', e.target.value)}
                    required
                    disabled={isLoading}
                  >
                    <option value="">Seçiniz</option>
                    {Object.entries(DIKEY_DIRECTION_TYPES).map(([key, value]) => (
                      <option key={key} value={value}>{value}</option>
                    ))}
                  </select>
                </div>

                {newOrder.usedM2 && (
                  <div className="form-group">
                    <label>Kullanılan Mt²</label>
                    <input
                      type="text"
                      value={newOrder.usedM2}
                      readOnly
                      className="readonly-field"
                    />
                  </div>
                )}

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Birim Fiyat (₺) *</label>
                    <button
                      type="button"
                      className={`lock-btn ${showBaseCost ? 'active' : ''}`}
                      onClick={() => setShowBaseCost(!showBaseCost)}
                      title="Maliyet Bilgisi"
                    >
                      <i className={`fas ${showBaseCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    min="0.01"
                    value={newOrder.unitPrice}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => {
                      onFieldChange('unitPrice', e.target.value);
                      onFieldChange('baseUnitPrice', e.target.value);
                      onFieldChange('baseUnitCost', '');
                      onFieldChange('unitCost', '');
                    }}
                    required
                    disabled={isLoading}
                  />
                </div>

                {showBaseCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Birim Maliyet (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={newOrder.unitCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => {
                        onFieldChange('unitCost', e.target.value);
                        onFieldChange('baseUnitCost', e.target.value);
                        if (newOrder.hasDikeyFon) {
                          onFieldChange('hasDikeyFon', false);
                          onFieldChange('unitPrice', newOrder.baseUnitPrice);
                        }
                      }}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Motor</label>
                  <select
                    value={newOrder.motorType || ''}
                    onChange={(e) => onFieldChange('motorType', e.target.value)}
                    disabled={isLoading}
                  >
                    <option value="">Seçiniz</option>
                    {Object.entries(MOTOR_TYPES).map(([key, value]) => (
                      <option key={key} value={value}>{value}</option>
                    ))}
                  </select>
                </div>

                {newOrder.motorType && (
                  <div className="form-group">
                    <label>Motor Ücreti ({getMotorCurrency()})</label>
                    <input
                      type="number"
                      step="0.01"
                      value={newOrder.motorPriceCurrency || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('motorPriceCurrency', e.target.value)}
                      disabled={isLoading}
                    />
                    {newOrder.motorPriceCurrency && (
                      <small style={{ display: 'block', marginTop: '5px', color: '#b04309' }}>
                        ≈ {newOrder.motorPrice ? Number(newOrder.motorPrice).toFixed(2) : 0} ₺
                      </small>
                    )}
                  </div>
                )}

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Montaj (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn ${showMountingCost ? 'active' : ''}`}
                      onClick={() => setShowMountingCost(!showMountingCost)}
                      title="Montaj Maliyet Girişi"
                    >
                      <i className={`fas ${showMountingCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>

                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.mounting}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('mounting', e.target.value)}
                    disabled={isLoading}
                  />
                </div>
                {showMountingCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Montaj Maliyeti (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={newOrder.mountingCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('mountingCost', e.target.value)}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Adet *</label>
                  <input
                    type="number"
                    step="1"
                    min="1"
                    value={newOrder.quantity || ''}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('quantity', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    value={newOrder.discount}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('discount', e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.totalPrice)}
                      readOnly
                      className="total-price"
                    />
                  </div>
                )}

                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.discountedPrice)}
                      readOnly
                      className="discounted-price"
                    />
                  </div>
                )}
              </>
            )}

            {/* Dikey Perde için özel alanlar */}
            {selectedProductType === 'dikeyPerde' && (
              <>
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input
                      type="text"
                      value={newOrder.roomName}
                      onChange={(e) => onFieldChange('roomName', e.target.value)}
                      disabled={isLoading}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
                      (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('productName', '');
                        onFieldChange('unitPrice', '');
                      } else if (option.__isNew__) {
                        onFieldChange('productName', option.value);
                        onFieldChange('unitPrice', '');
                      } else {
                        handleProductSelect(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>

                <div className="form-group">
                  <label>Ürün Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.productVariant || ''}
                    onChange={(e) => onFieldChange('productVariant', e.target.value)}
                    disabled={isLoading}
                    placeholder="Ürün varyantı"
                  />
                </div>

                <div className="form-group">
                  <label>En (cm) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.width}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('width', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>Boy (cm) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.height}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('height', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>Yön *</label>
                  <select
                    value={newOrder.direction || ''}
                    onChange={(e) => onFieldChange('direction', e.target.value)}
                    required
                    disabled={isLoading}
                  >
                    <option value="">Seçiniz</option>
                    {Object.entries(DIKEY_DIRECTION_TYPES).map(([key, value]) => (
                      <option key={key} value={value}>{value}</option>
                    ))}
                  </select>
                </div>

                {newOrder.usedM2 && (
                  <div className="form-group">
                    <label>Kullanılan Mt²</label>
                    <input
                      type="text"
                      value={newOrder.usedM2}
                      readOnly
                      className="readonly-field"
                    />
                  </div>
                )}

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Birim Fiyat (₺) *</label>
                    <button
                      type="button"
                      className={`lock-btn ${showBaseCost ? 'active' : ''}`}
                      onClick={() => setShowBaseCost(!showBaseCost)}
                      title="Maliyet Bilgisi"
                    >
                      <i className={`fas ${showBaseCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    min="0.01"
                    value={newOrder.unitPrice}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => {
                      onFieldChange('unitPrice', e.target.value);
                      onFieldChange('baseUnitPrice', e.target.value);
                      onFieldChange('baseUnitCost', '');
                      onFieldChange('unitCost', '');
                      if (newOrder.hasDikeyFon) onFieldChange('hasDikeyFon', false);
                    }}
                    required
                    disabled={isLoading}
                  />
                </div>

                {showBaseCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Birim Maliyet (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={newOrder.unitCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => {
                        onFieldChange('unitCost', e.target.value);
                        onFieldChange('baseUnitCost', e.target.value);
                        if (newOrder.hasDikeyFon) {
                          onFieldChange('hasDikeyFon', false);
                          onFieldChange('unitPrice', newOrder.baseUnitPrice);
                        }
                      }}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>&nbsp;</label>
                  <label
                    style={{
                      display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px',
                      border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%',
                      backgroundColor: !newOrder.unitPrice ? '#f1f5f9' : '#f8fafc',
                      cursor: !newOrder.unitPrice ? 'not-allowed' : 'pointer',
                      margin: 0, transition: 'all 0.2s ease',
                      opacity: !newOrder.unitPrice ? 0.6 : 1
                    }}
                    onMouseOver={(e) => {
                      if (newOrder.unitPrice) {
                        e.currentTarget.style.borderColor = '#94a3b8';
                        e.currentTarget.style.backgroundColor = '#f1f5f9';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (newOrder.unitPrice) {
                        e.currentTarget.style.borderColor = '#cbd5e1';
                        e.currentTarget.style.backgroundColor = '#f8fafc';
                      }
                    }}
                  >
                    <input
                      type="checkbox"
                      disabled={!newOrder.unitPrice || isLoading}
                      style={{
                        width: '16px', height: '16px', marginRight: '10px',
                        cursor: !newOrder.unitPrice ? 'not-allowed' : 'pointer',
                        accentColor: '#b04309'
                      }}
                      checked={newOrder.hasDikeyFon || false}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        onFieldChange('hasDikeyFon', checked);

                        const fonPrice = Number(getSettingPrice('dikeyFon')) || 0;
                        const fonCost = Number(getSettingCost('dikeyFon')) || 0;

                        // Amount alanını sadece bilgi amaçlı güncelleyelim
                        onFieldChange('dikeyFonAmount', checked ? fonPrice : 0);

                        const baseP = parseFloat(newOrder.baseUnitPrice) || 0;
                        const baseC = parseFloat(newOrder.baseUnitCost) || 0;

                        // Birim fiyat ve maliyete ekle/çıkar (base üzerinden)
                        const newUnitP = checked ? baseP + fonPrice : baseP;
                        const newUnitC = checked ? baseC + fonCost : baseC;

                        onFieldChange('unitPrice', newUnitP > 0 ? newUnitP.toFixed(2) : '');
                        onFieldChange('unitCost', newUnitC > 0 ? newUnitC.toFixed(2) : '');
                        onFieldChange('baseUnitCost', baseC > 0 ? baseC.toFixed(2) : '');

                        // Fon sayısı seçiliyse varsayılan olarak 1 atayalım
                        if (checked && !newOrder.dikeyFonCount) {
                          onFieldChange('dikeyFonCount', 1);
                        }
                      }}
                    />
                    <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Fon (+{getSettingPrice('dikeyFon')} ₺)</span>
                  </label>
                </div>

                {newOrder.hasDikeyFon && (
                  <>
                    <div className="form-group">
                      <label>Fon Adı *</label>
                      {adminSettings.dikeyFonList && adminSettings.dikeyFonList.length > 0 ? (
                        <Select
                          options={adminSettings.dikeyFonList.map(f => ({ value: f, label: f }))}
                          value={newOrder.dikeyFonName ? { value: newOrder.dikeyFonName, label: newOrder.dikeyFonName } : null}
                          onChange={(option) => onFieldChange('dikeyFonName', option ? option.value : '')}
                          isDisabled={isLoading}
                          isClearable
                          isSearchable
                          placeholder="Fon seçiniz..."
                          noOptionsMessage={() => "Fon bulunamadı"}
                          styles={customSelectStyles}
                        />
                      ) : (
                        <input
                          type="text"
                          value={newOrder.dikeyFonName || ''}
                          onChange={(e) => onFieldChange('dikeyFonName', e.target.value)}
                          disabled={isLoading}
                          placeholder="Fon adı girin (Fon ürünleri listesi boş)"
                        />
                      )}
                    </div>
                    <div className="form-group">
                      <label>Fon Sayısı</label>
                      <input
                        type="number"
                        step="1"
                        min="1"
                        value={newOrder.dikeyFonCount || ''}
                        onChange={(e) => {
                          let val = e.target.value;
                          if (val !== '' && parseInt(val) < 1) val = '1';
                          onFieldChange('dikeyFonCount', val);
                        }}
                        disabled={isLoading}
                      />
                    </div>
                  </>
                )}

                <div className="form-group">
                  <label>Motor</label>
                  <select
                    value={newOrder.motorType || ''}
                    onChange={(e) => onFieldChange('motorType', e.target.value)}
                    disabled={isLoading}
                  >
                    <option value="">Seçiniz</option>
                    {Object.entries(MOTOR_TYPES).map(([key, value]) => (
                      <option key={key} value={value}>{value}</option>
                    ))}
                  </select>
                </div>

                {newOrder.motorType && (
                  <div className="form-group">
                    <label>Motor Ücreti ({getMotorCurrency()})</label>
                    <input
                      type="number"
                      step="0.01"
                      value={newOrder.motorPriceCurrency || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('motorPriceCurrency', e.target.value)}
                      disabled={isLoading}
                    />
                    {newOrder.motorPriceCurrency && (
                      <small style={{ display: 'block', marginTop: '5px', color: '#b04309' }}>
                        ≈ {newOrder.motorPrice ? Number(newOrder.motorPrice).toFixed(2) : 0} ₺
                      </small>
                    )}
                  </div>
                )}

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Montaj (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn ${showMountingCost ? 'active' : ''}`}
                      onClick={() => setShowMountingCost(!showMountingCost)}
                      title="Montaj Maliyet Girişi"
                    >
                      <i className={`fas ${showMountingCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>

                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.mounting}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('mounting', e.target.value)}
                    disabled={isLoading}
                  />
                </div>
                {showMountingCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Montaj Maliyeti (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={newOrder.mountingCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('mountingCost', e.target.value)}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Adet *</label>
                  <input
                    type="number"
                    step="1"
                    min="1"
                    value={newOrder.quantity || ''}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('quantity', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    value={newOrder.discount}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('discount', e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.totalPrice)}
                      readOnly
                      className="total-price"
                    />
                  </div>
                )}

                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.discountedPrice)}
                      readOnly
                      className="discounted-price"
                    />
                  </div>
                )}
              </>
            )}

            {/* Plise için özel alanlar - Yeni Batch Sistemi */}
            {selectedProductType === 'plise' && (
              <>
                {/* Başlık Alanları */}
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input
                      type="text"
                      value={newOrder.roomName}
                      onChange={(e) => onFieldChange('roomName', e.target.value)}
                      disabled={isLoading}
                      placeholder="Örn: Salon"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>1. Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.label === newOrder.pliseProduct1Name) ||
                      (newOrder.pliseProduct1Name ? { value: newOrder.pliseProduct1Name, label: newOrder.pliseProduct1Name } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('pliseProduct1Name', '');
                        onFieldChange('pliseProduct1Price', '');
                      } else if (option.__isNew__) {
                        onFieldChange('pliseProduct1Name', option.value);
                        onFieldChange('pliseProduct1Price', '');
                      } else {
                        handlePliseProduct1Select(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>

                <div className="form-group">
                  <label>1. Ürün Fiyat (₺) *</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0.01"
                    value={parseInt(newOrder.pliseProduct1Price) === 0 ? '' : newOrder.pliseProduct1Price}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('pliseProduct1Price', e.target.value)}
                    disabled={isLoading}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>1. Ürün Kumaş Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.pliseProduct1Variation || ''}
                    onChange={(e) => onFieldChange('pliseProduct1Variation', e.target.value)}
                    disabled={isLoading}
                    placeholder="Renk/Desen"
                  />
                </div>

                <div className="form-group">
                  <label>Kasa Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.pliseCaseVariation || ''}
                    onChange={(e) => onFieldChange('pliseCaseVariation', e.target.value)}
                    disabled={isLoading}
                    placeholder="Örn: Antrasit"
                  />
                </div>

                <div className="form-group">
                  <label>2. Ürün Adı</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.label === newOrder.pliseProduct2Name) ||
                      (newOrder.pliseProduct2Name ? { value: newOrder.pliseProduct2Name, label: newOrder.pliseProduct2Name } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('pliseProduct2Name', '');
                        onFieldChange('pliseProduct2Price', '');
                      } else if (option.__isNew__) {
                        onFieldChange('pliseProduct2Name', option.value);
                        onFieldChange('pliseProduct2Price', '');
                      } else {
                        handlePliseProduct2Select(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>

                <div className="form-group">
                  <label>2. Ürün Fiyat (₺)</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={parseInt(newOrder.pliseProduct2Price) === 0 ? '' : newOrder.pliseProduct2Price}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('pliseProduct2Price', e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>2. Ürün Kumaş Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.pliseProduct2Variation || ''}
                    onChange={(e) => onFieldChange('pliseProduct2Variation', e.target.value)}
                    disabled={isLoading}
                    placeholder="Renk/Desen"
                  />
                </div>

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Montaj Toplam (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn ${showMountingCost ? 'active' : ''}`}
                      onClick={() => setShowMountingCost(!showMountingCost)}
                      title="Montaj Maliyet Girişi"
                    >
                      <i className={`fas ${showMountingCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.mounting}
                    onChange={(e) => onFieldChange('mounting', e.target.value)}
                    placeholder="0.00"
                    disabled={isLoading}
                  />
                </div>
                {showMountingCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Montaj Maliyeti (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={newOrder.mountingCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('mountingCost', e.target.value)}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                {/* Dinamik Ölçü Listesi Section */}
                <div style={{ gridColumn: '1 / -1', padding: '15px', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0', marginTop: '20px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h4 style={{ margin: 0, fontSize: '16px', color: '#0f172a', fontWeight: '700', display: 'flex', alignItems: 'center' }}>
                      <i className="fas fa-layer-group" style={{ marginRight: '10px', color: '#b04309' }}></i>
                      Plise Ölçü ve Adet Listesi
                    </h4>
                    <button
                      type="button"
                      onClick={() => {
                        const newList = [...(newOrder.pliseItems || []), { id: Date.now(), width: '', height: '', usedM2: '1.00', quantity: '1', multisistem: false, rowTotal: '0.00' }];
                        onFieldChange('pliseItems', newList);
                      }}
                      style={{ padding: '8px 16px', backgroundColor: '#0f172a', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: '600', transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: '8px' }}
                      onMouseOver={(e) => e.target.style.backgroundColor = '#1e293b'}
                      onMouseOut={(e) => e.target.style.backgroundColor = '#0f172a'}
                    >
                      <i className="fas fa-plus"></i>
                      Yeni Ölçü Ekle
                    </button>
                  </div>

                  <div className="plise-batch-wrapper">
                    <table className="plise-batch-table">
                      <thead>
                        <tr>
                          <th>En (cm)</th>
                          <th>Boy (cm)</th>
                          <th>m²</th>
                          <th>Adet</th>
                          <th style={{ textAlign: 'center' }}>Multisistem</th>
                          <th style={{ textAlign: 'right' }}>Tutar (₺)</th>
                          <th style={{ textAlign: 'center' }}>İşlemler</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(newOrder.pliseItems) && newOrder.pliseItems.length > 0 ? (
                          newOrder.pliseItems.map((item, idx) => (
                            <tr key={item.id || idx} className="plise-row">
                              <td data-label="En (cm)">
                                <input
                                  type="number"
                                  value={item.width}
                                  onChange={(e) => {
                                    const newList = [...newOrder.pliseItems];
                                    newList[idx].width = e.target.value;
                                    onFieldChange('pliseItems', newList);
                                  }}
                                  className="plise-input"
                                  placeholder="En"
                                />
                              </td>
                              <td data-label="Boy (cm)">
                                <input
                                  type="number"
                                  value={item.height}
                                  onChange={(e) => {
                                    const newList = [...newOrder.pliseItems];
                                    newList[idx].height = e.target.value;
                                    onFieldChange('pliseItems', newList);
                                  }}
                                  className="plise-input"
                                  placeholder="Boy"
                                />
                              </td>
                              <td data-label="m²">
                                <div className="plise-m2-badge">
                                  {item.usedM2 || '1.00'}
                                </div>
                              </td>
                              <td data-label="Adet">
                                <input
                                  type="number"
                                  min="1"
                                  value={item.quantity}
                                  onChange={(e) => {
                                    const newList = [...newOrder.pliseItems];
                                    newList[idx].quantity = e.target.value;
                                    onFieldChange('pliseItems', newList);
                                  }}
                                  className="plise-input qty-input"
                                />
                              </td>
                              <td data-label="Multisistem" style={{ textAlign: 'center' }}>
                                <input
                                  type="checkbox"
                                  checked={item.multisistem}
                                  onChange={(e) => {
                                    const newList = [...newOrder.pliseItems];
                                    newList[idx].multisistem = e.target.checked;
                                    onFieldChange('pliseItems', newList);
                                  }}
                                  className="plise-checkbox"
                                />
                              </td>
                              <td data-label="Tutar (₺)">
                                <div className="plise-row-total">
                                  {formatPrice(item.rowTotal || 0)} ₺
                                </div>
                              </td>
                              <td data-label="İşlemler">
                                <div className="plise-actions">
                                  <button
                                    type="button"
                                    className="plise-action-btn copy"
                                    title="Satırı Kopyala"
                                    onClick={() => {
                                      const rowToCopy = { ...newOrder.pliseItems[idx], id: Date.now() + Math.random() };
                                      const newList = [...newOrder.pliseItems];
                                      newList.splice(idx + 1, 0, rowToCopy);
                                      onFieldChange('pliseItems', newList);
                                    }}
                                  >
                                    <i className="fas fa-copy"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="plise-action-btn delete"
                                    title="Satırı Sil"
                                    onClick={() => {
                                      const newList = newOrder.pliseItems.filter((_, i) => i !== idx);
                                      onFieldChange('pliseItems', newList);
                                    }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="empty-message">
                              Henüz bir ölçü eklenmedi. Hızlıca eklemek için "Yeni Ölçü Ekle" butonunu kullanın.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Ek Ücret (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn ${showExtraCost ? 'active' : ''}`}
                      onClick={() => setShowExtraCost(!showExtraCost)}
                      title="Ek Maliyet Girişi"
                    >
                      <i className={`fas ${showExtraCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={newOrder.extraPrice}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => {
                      onFieldChange('extraPrice', e.target.value);
                      onFieldChange('manualExtraCost', '');
                    }}
                    disabled={isLoading}
                  />
                </div>

                {showExtraCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Ek Ücret Maliyeti (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={newOrder.manualExtraCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('manualExtraCost', e.target.value)}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input
                    type="number"
                    value={newOrder.discount}
                    onChange={(e) => onFieldChange('discount', e.target.value)}
                    min="0"
                    max="100"
                    placeholder="0"
                    disabled={isLoading}
                  />
                </div>

                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.totalPrice)}
                      readOnly
                      className="total-price"
                    />
                  </div>
                )}

                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.discountedPrice)}
                      readOnly
                      className="discounted-price"
                    />
                  </div>
                )}
              </>
            )}

            {/* Katlamalı Perde için özel alanlar */}
            {selectedProductType === 'katlamaliPerde' && (
              <>
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input
                      type="text"
                      value={newOrder.roomName}
                      onChange={(e) => onFieldChange('roomName', e.target.value)}
                      disabled={isLoading}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
                      (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('productName', '');
                        onFieldChange('unitPrice', '');
                      } else if (option.__isNew__) {
                        onFieldChange('productName', option.value);
                        onFieldChange('unitPrice', '');
                      } else {
                        handleProductSelect(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>

                <div className="form-group">
                  <label>Ürün Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.productVariant || ''}
                    onChange={(e) => onFieldChange('productVariant', e.target.value)}
                    disabled={isLoading}
                    placeholder="Renk, desen vb. giriniz..."
                  />
                </div>

                <div className="form-group">
                  <label>En (cm) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.width}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('width', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>Boy (cm) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.height}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('height', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                {newOrder.usedM2 && (
                  <div className="form-group">
                    <label>Kullanılan Mt</label>
                    <input
                      type="text"
                      value={newOrder.usedM2}
                      readOnly
                      className="readonly-field"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Kumaş (₺) *</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0.01"
                    value={newOrder.fabricPrice}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('fabricPrice', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>Mekanizma Tipi *</label>
                  {adminSettings.katlamaliMekanizmaList && adminSettings.katlamaliMekanizmaList.length > 0 ? (
                    <Select
                      options={adminSettings.katlamaliMekanizmaList.map(m => {
                        const wPrice = (m.wholesale !== undefined && m.wholesale !== null && m.wholesale !== 0) ? m.wholesale : m.price;
                        const dispPrice = isWholesale ? wPrice : m.price;
                        return { value: m.type, label: `${m.type} (${dispPrice} ₺)` };
                      })}
                      value={newOrder.mechanismType ? { value: newOrder.mechanismType, label: newOrder.mechanismType } : null}
                      onChange={(option) => handleKatlamaliMechanismSelect(option ? option.value : '')}
                      isDisabled={isLoading}
                      isClearable
                      isSearchable
                      placeholder="Seçiniz..."
                      styles={customSelectStyles}
                    />
                  ) : (
                    <input
                      type="text"
                      value={newOrder.mechanismType || ''}
                      onChange={(e) => onFieldChange('mechanismType', e.target.value)}
                      disabled={isLoading}
                      placeholder="Mekanizma tipi girin"
                    />
                  )}
                </div>

                <div className="form-group">
                  <label>Mekanizma (₺) *</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0.01"
                    value={newOrder.mechanismPrice}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('mechanismPrice', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                {/* Aksesuarlar Bölümü */}
                <div style={{ gridColumn: '1 / -1', padding: '15px', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0', marginTop: '10px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h4 style={{ margin: 0, fontSize: '15px', color: '#b04309' }}>
                      <i className="fas fa-tags" style={{ marginRight: '8px' }}></i>
                      Aksesuarlar
                    </h4>
                    <button
                      type="button"
                      onClick={handleAddAccessory}
                      style={{ padding: '6px 12px', backgroundColor: '#0f172a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}
                    >
                      <i className="fas fa-plus" style={{ marginRight: '5px' }}></i>
                      Aksesuar Ekle
                    </button>
                  </div>

                  {Array.isArray(newOrder.accessories) && newOrder.accessories.length > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      {newOrder.accessories.map((acc, idx) => (
                        <div key={acc.id} className="aksesuar-item-row">
                          <div className="form-group" style={{ marginBottom: 0 }}>
                            <label style={{ fontSize: '11px' }}>Aksesuar Adı</label>
                            <input
                              type="text"
                              value={acc.name}
                              onChange={(e) => handleAccessoryChange(acc.id, 'name', e.target.value)}
                              placeholder="Fisto, Boncuk vb."
                              style={{ padding: '6px' }}
                            />
                          </div>
                          <div className="form-group" style={{ marginBottom: 0 }}>
                            <label style={{ fontSize: '11px' }}>Fiyat (₺)</label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              value={acc.price}
                              onKeyDown={handleNumericKeyDown}
                              onChange={(e) => handleAccessoryChange(acc.id, 'price', e.target.value)}
                              style={{ padding: '6px' }}
                            />
                          </div>
                          <div className="form-group" style={{ marginBottom: 0 }}>
                            <label style={{ fontSize: '11px' }}>Adet</label>
                            <input
                              type="number"
                              step="1"
                              min="1"
                              value={acc.quantity}
                              onKeyDown={handleNumericKeyDown}
                              onChange={(e) => handleAccessoryChange(acc.id, 'quantity', e.target.value)}
                              style={{ padding: '6px' }}
                            />
                          </div>
                          <div className="form-group" style={{ marginBottom: 0 }}>
                            <label style={{ fontSize: '11px' }}>Tutar (₺)</label>
                            <input
                              type="text"
                              value={acc.total}
                              readOnly
                              style={{ padding: '6px', backgroundColor: '#f1f5f9' }}
                            />
                          </div>
                          <button
                            type="button"
                            onClick={() => handleRemoveAccessory(acc.id)}
                            style={{ padding: '8px', color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer' }}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={{ fontSize: '13px', color: '#64748b', textAlign: 'center', margin: '10px 0' }}>Henüz aksesuar eklenmemiş.</p>
                  )}
                </div>

                {/* Motor Bölümü */}
                <div className="form-group">
                  <label>Motor</label>
                  <select
                    value={newOrder.motorType || ''}
                    onChange={(e) => onFieldChange('motorType', e.target.value)}
                    disabled={isLoading}
                  >
                    <option value="">Seçiniz</option>
                    {Object.entries(MOTOR_TYPES).map(([key, value]) => (
                      <option key={key} value={value}>{value}</option>
                    ))}
                  </select>
                </div>

                {newOrder.motorType && (
                  <div className="form-group">
                    <label>Motor Ücreti ({getMotorCurrency()})</label>
                    <input
                      type="number"
                      step="0.01"
                      value={newOrder.motorPriceCurrency || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('motorPriceCurrency', e.target.value)}
                      disabled={isLoading}
                    />
                    {newOrder.motorPriceCurrency && (
                      <small style={{ display: 'block', marginTop: '5px', color: '#b04309' }}>
                        ≈ {newOrder.motorPrice ? Number(newOrder.motorPrice).toFixed(2) : 0} ₺
                      </small>
                    )}
                  </div>
                )}

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Montaj (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn ${showMountingCost ? 'active' : ''}`}
                      onClick={() => setShowMountingCost(!showMountingCost)}
                      title="Montaj Maliyet Girişi"
                    >
                      <i className={`fas ${showMountingCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>

                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.mounting}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('mounting', e.target.value)}
                    disabled={isLoading}
                  />
                </div>
                {showMountingCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Montaj Maliyeti (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={newOrder.mountingCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('mountingCost', e.target.value)}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Adet *</label>
                  <input
                    type="number"
                    step="1"
                    min="1"
                    value={newOrder.quantity || ''}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('quantity', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    value={newOrder.discount}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('discount', e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.totalPrice)}
                      readOnly
                      className="total-price"
                    />
                  </div>
                )}

                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.discountedPrice)}
                      readOnly
                      className="discounted-price"
                    />
                  </div>
                )}
              </>
            )}

            {/* Aksesuar için özel alanlar */}
            {selectedProductType === 'aksesuar' && (
              <>
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input
                      type="text"
                      value={newOrder.roomName}
                      onChange={(e) => onFieldChange('roomName', e.target.value)}
                      disabled={isLoading}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
                      (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('productName', '');
                        onFieldChange('unitPrice', '');
                      } else if (option.__isNew__) {
                        onFieldChange('productName', option.value);
                        onFieldChange('unitPrice', '');
                      } else {
                        handleProductSelect(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>

                <div className="form-group">
                  <label>Ürün Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.productVariant || ''}
                    onChange={(e) => onFieldChange('productVariant', e.target.value)}
                    disabled={isLoading}
                    placeholder="Renk, desen vb. giriniz..."
                  />
                </div>

                <div className="form-group">
                  <label>Birim Tipi</label>
                  <select
                    className="form-control"
                    value={newOrder.unitType || 'Adet'}
                    onChange={(e) => onFieldChange('unitType', e.target.value)}
                    disabled={isLoading}
                  >
                    <option value="Adet">Adet</option>
                    <option value="Metre">Metre</option>
                  </select>
                </div>

                {newOrder.unitType === 'Metre' && (
                  <div className="form-group">
                    <label>Metre *</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0.01"
                      value={newOrder.itemMeter}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('itemMeter', e.target.value)}
                      required
                      disabled={isLoading}
                      placeholder="Kaç metre?"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Adet *</label>
                  <input
                    type="number"
                    step="1"
                    min="1"
                    value={newOrder.quantity}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('quantity', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Birim Fiyat (₺) *</label>
                    <button
                      type="button"
                      className={`lock-btn ${showExtraCost ? 'active' : ''}`}
                      onClick={() => setShowExtraCost(!showExtraCost)}
                      title="Maliyet Girişi"
                    >
                      <i className={`fas ${showExtraCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={newOrder.unitPrice}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('unitPrice', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                {showExtraCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Birim Maliyeti (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={newOrder.manualExtraCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('manualExtraCost', e.target.value)}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    value={newOrder.discount}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('discount', e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.totalPrice)}
                      readOnly
                      className="total-price"
                    />
                  </div>
                )}

                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.discountedPrice)}
                      readOnly
                      className="discounted-price"
                    />
                  </div>
                )}
              </>
            )}

            {/* Ray Sistemleri için özel alanlar */}
            {selectedProductType === 'raySistemi' && (
              <>
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input
                      type="text"
                      value={newOrder.roomName}
                      onChange={(e) => onFieldChange('roomName', e.target.value)}
                      disabled={isLoading}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
                      (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('productName', '');
                        onFieldChange('unitPrice', '');
                      } else if (option.__isNew__) {
                        onFieldChange('productName', option.value);
                        onFieldChange('unitPrice', '');
                      } else {
                        handleProductSelect(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>

                <div className="form-group">
                  <label>Ürün Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.productVariant || ''}
                    onChange={(e) => onFieldChange('productVariant', e.target.value)}
                    disabled={isLoading}
                    placeholder="Renk, desen vb. giriniz..."
                  />
                </div>

                <div className="form-group">
                  <label>En (cm) *</label>
                  <input
                    type="number"
                    step="1"
                    value={newOrder.width}
                    onChange={(e) => onFieldChange('width', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>Ölçü Tamamlama *</label>
                  <select
                    value={newOrder.olcuTamamlama || ''}
                    onChange={(e) => onFieldChange('olcuTamamlama', e.target.value)}
                    required
                    disabled={isLoading}
                  >
                    <option value="">Seçiniz</option>
                    <option value="25cm">25cm'e tamamla</option>
                    <option value="50cm">50cm'e tamamla</option>
                    <option value="urunBoyutu">Ürün boyutu</option>
                  </select>
                </div>

                {newOrder.usedMeter && (
                  <div className="form-group">
                    <label>Kullanılan Metre</label>
                    <input
                      type="text"
                      value={newOrder.usedMeter + ' m'}
                      readOnly
                      className="readonly-field"
                    />
                  </div>
                )}

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Birim Fiyat (₺) *</label>
                    <button
                      type="button"
                      className={`lock-btn ${showBaseCost ? 'active' : ''}`}
                      onClick={() => setShowBaseCost(!showBaseCost)}
                      title="Maliyet Bilgisi"
                    >
                      <i className={`fas ${showBaseCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    min="0.01"
                    value={newOrder.unitPrice}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => {
                      onFieldChange('unitPrice', e.target.value);
                      onFieldChange('baseUnitCost', '');
                    }}
                    required
                    disabled={isLoading}
                  />
                </div>

                {showBaseCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Birim Maliyet (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={newOrder.baseUnitCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('baseUnitCost', e.target.value)}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}


                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Montaj (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn ${showMountingCost ? 'active' : ''}`}
                      onClick={() => setShowMountingCost(!showMountingCost)}
                      title="Montaj Maliyet Girişi"
                    >
                      <i className={`fas ${showMountingCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>

                  <input
                    type="number"
                    step="0.01"
                    value={newOrder.mounting || ''}
                    onChange={(e) => onFieldChange('mounting', e.target.value)}
                    disabled={isLoading}
                  />
                </div>
                {showMountingCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Montaj Maliyeti (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={newOrder.mountingCost || ''}
                      onChange={(e) => onFieldChange('mountingCost', e.target.value)}
                      onKeyDown={handleNumericKeyDown}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Adet *</label>
                  <input
                    type="number"
                    step="1"
                    min="1"
                    value={newOrder.quantity || ''}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('quantity', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    value={newOrder.discount}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => onFieldChange('discount', e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.totalPrice)}
                      readOnly
                      className="total-price"
                    />
                  </div>
                )}

                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.discountedPrice)}
                      readOnly
                      className="discounted-price"
                    />
                  </div>
                )}
              </>
            )}

            {/* Rustik için özel alanlar */}
            {selectedProductType === 'rustik' && (
              <>
                {!isWholesale && (
                  <div className="form-group">
                    <label>Oda Adı</label>
                    <input
                      type="text"
                      value={newOrder.roomName}
                      onChange={(e) => onFieldChange('roomName', e.target.value)}
                      disabled={isLoading}
                      placeholder="Örn: Salon"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Ürün Adı *</label>
                  <CreatableSelect
                    options={productOptions}
                    value={
                      productOptions.find(o => o.label === newOrder.productName) ||
                      (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
                    }
                    onChange={(option) => {
                      if (!option) {
                        onFieldChange('productName', '');
                        onFieldChange('unitPrice', '');
                      } else if (option.__isNew__) {
                        onFieldChange('productName', option.value);
                        onFieldChange('unitPrice', '');
                      } else {
                        handleProductSelect(option.value);
                      }
                    }}
                    isDisabled={isLoading}
                    isClearable
                    isSearchable
                    placeholder="Ürün seçin veya yazın..."
                    noOptionsMessage={() => "Ürün bulunamadı"}
                    formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
                    styles={customSelectStyles}
                  />
                </div>
                <div className="form-group">
                  <label>Ürün Varyantı</label>
                  <input
                    type="text"
                    value={newOrder.productVariant || ''}
                    onChange={(e) => onFieldChange('productVariant', e.target.value)}
                    disabled={isLoading}
                    placeholder="Renk, desen vb. giriniz..."
                  />
                </div>

                <div className="form-group">
                  <label>En (cm) *</label>
                  <input
                    type="number"
                    value={newOrder.width}
                    onChange={(e) => onFieldChange('width', e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>Kullanılan Cm</label>
                  <input
                    type="number"
                    value={newOrder.usedCm}
                    readOnly
                    disabled={isLoading}
                    className="readonly-field"
                    title="En değerine göre otomatik hesaplanır (min 120, 40'ın katı)"
                  />
                </div>

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Birim Fiyat (₺) *</label>
                    <button
                      type="button"
                      className={`lock-btn ${showBaseCost ? 'active' : ''}`}
                      onClick={() => setShowBaseCost(!showBaseCost)}
                      title="Maliyet Bilgisi"
                    >
                      <i className={`fas ${showBaseCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    min="0.01"
                    value={newOrder.unitPrice}
                    onKeyDown={handleNumericKeyDown}
                    onChange={(e) => {
                      onFieldChange('unitPrice', e.target.value);
                      onFieldChange('baseUnitCost', '');
                    }}
                    required
                    disabled={isLoading}
                  />
                </div>

                {showBaseCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Birim Maliyet (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={newOrder.baseUnitCost || ''}
                      onKeyDown={handleNumericKeyDown}
                      onChange={(e) => onFieldChange('baseUnitCost', e.target.value)}
                      disabled={isLoading}
                      placeholder="Gizli maliyet"
                    />
                  </div>
                )}


                {/* Ayak Ayarları */}
                <div className="form-group">
                  <label>Ayak Modeli *</label>
                  {adminSettings.rustikAyakModelList?.length > 0 ? (
                    <Select
                      options={adminSettings.rustikAyakModelList.map(m => ({ value: m, label: m }))}
                      value={newOrder.ayakModel ? { value: newOrder.ayakModel, label: newOrder.ayakModel } : null}
                      onChange={(option) => onFieldChange('ayakModel', option ? option.value : '')}
                      styles={customSelectStyles}
                      isClearable
                    />
                  ) : (
                    <input type="text" value={newOrder.ayakModel} onChange={(e) => onFieldChange('ayakModel', e.target.value)} required />
                  )}
                </div>

                <div className="form-group">
                  <label>Ayak Çapı *</label>
                  {adminSettings.rustikAyakCapList?.length > 0 ? (
                    <Select
                      options={adminSettings.rustikAyakCapList.map(m => ({ value: m, label: m }))}
                      value={newOrder.ayakCap ? { value: newOrder.ayakCap, label: newOrder.ayakCap } : null}
                      onChange={(option) => onFieldChange('ayakCap', option ? option.value : '')}
                      styles={customSelectStyles}
                      isClearable
                    />
                  ) : (
                    <input type="text" value={newOrder.ayakCap} onChange={(e) => onFieldChange('ayakCap', e.target.value)} required />
                  )}
                </div>

                <div className="form-group">
                  <label>Ayak Uzunluğu *</label>
                  {adminSettings.rustikAyakUzunlukList?.length > 0 ? (
                    <Select
                      options={adminSettings.rustikAyakUzunlukList.map(m => ({ value: m, label: m }))}
                      value={newOrder.ayakUzunluk ? { value: newOrder.ayakUzunluk, label: newOrder.ayakUzunluk } : null}
                      onChange={(option) => onFieldChange('ayakUzunluk', option ? option.value : '')}
                      styles={customSelectStyles}
                      isClearable
                    />
                  ) : (
                    <input type="text" value={newOrder.ayakUzunluk} onChange={(e) => onFieldChange('ayakUzunluk', e.target.value)} required />
                  )}
                </div>

                <div className="form-group">
                  <label>Renk Kodu *</label>
                  {adminSettings.rustikAyakRenkKoduList?.length > 0 ? (
                    <Select
                      options={adminSettings.rustikAyakRenkKoduList.map(m => ({ value: m, label: m }))}
                      value={newOrder.ayakRenkKodu ? { value: newOrder.ayakRenkKodu, label: newOrder.ayakRenkKodu } : null}
                      onChange={(option) => onFieldChange('ayakRenkKodu', option ? option.value : '')}
                      styles={customSelectStyles}
                      isClearable
                    />
                  ) : (
                    <input type="text" value={newOrder.ayakRenkKodu} onChange={(e) => onFieldChange('ayakRenkKodu', e.target.value)} required />
                  )}
                </div>

                <div className="form-group">
                  <label>Ayak Sayısı *</label>
                  <Select
                    options={[1, 2, 3, 4, 5].map(v => ({ value: v, label: v }))}
                    value={newOrder.ayakSayisi ? { value: newOrder.ayakSayisi, label: newOrder.ayakSayisi } : null}
                    onChange={(option) => onFieldChange('ayakSayisi', option ? option.value : '')}
                    styles={customSelectStyles}
                  />
                  <span className="field-hint">En değerine göre otomatik seçilir, değiştirilebilir.</span>
                </div>

                <div className="form-group">
                  <label>Ek Ayak Sayısı</label>
                  <Select
                    options={[1, 2, 3, 4, 5].map(v => ({ value: v, label: v }))}
                    value={newOrder.ekAyakSayisi ? { value: newOrder.ekAyakSayisi, label: newOrder.ekAyakSayisi } : null}
                    onChange={(option) => onFieldChange('ekAyakSayisi', option ? option.value : '')}
                    styles={customSelectStyles}
                    isClearable
                  />
                </div>

                <div className={`form-group rustik-ayak-fee-group${showAyakUcretiCost ? ' is-cost-open' : ''}`}>
                  <div className="label-with-icon">
                    <label>Ayak Ücreti (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn rustik-cost-toggle ${showAyakUcretiCost ? 'active' : ''}`}
                      onClick={() => setShowAyakUcretiCost(!showAyakUcretiCost)}
                      title={showAyakUcretiCost ? 'Ayak maliyet alanını gizle' : 'Ayak maliyet alanını göster'}
                    >
                      <i className={`fas ${showAyakUcretiCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    onKeyDown={handleNumericKeyDown}
                    value={newOrder.ayakUcreti}
                    onChange={(e) => onFieldChange('ayakUcreti', e.target.value)}
                  />
                  {showAyakUcretiCost && (
                    <div className="rustik-inline-cost-panel">
                      <div className="rustik-cost-panel-badge">
                        <i className="fas fa-shield-halved"></i>
                        <span>Gizli Maliyet</span>
                      </div>
                      <div className="form-group rustik-cost-field">
                        <label>Ayak Birim Maliyeti (₺)</label>
                        <div className="rustik-cost-input-wrap">
                          <span className="rustik-cost-prefix">₺</span>
                          <input
                            type="number"
                            step="0.01"
                            min="0"
                            onKeyDown={handleNumericKeyDown}
                            value={newOrder.ayakUcretiCost || ''}
                            onChange={(e) => onFieldChange('ayakUcretiCost', e.target.value)}
                            disabled={isLoading}
                            placeholder="0,00"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <div className="label-with-icon">
                    <label>Montaj (₺)</label>
                    <button
                      type="button"
                      className={`lock-btn ${showMountingCost ? 'active' : ''}`}
                      onClick={() => setShowMountingCost(!showMountingCost)}
                      title="Montaj Maliyet Girişi"
                    >
                      <i className={`fas ${showMountingCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                    </button>
                  </div>

                  <input type="number" step="0.01" value={newOrder.mounting} onChange={(e) => onFieldChange('mounting', e.target.value)} />
                </div>
                {showMountingCost && (
                  <div className="form-group">
                    <label className="extra-cost-label">Montaj Maliyeti (₺)</label>
                    <input type="number" step="0.01" value={newOrder.mountingCost || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('mountingCost', e.target.value)} disabled={isLoading} placeholder="Gizli maliyet" />
                  </div>
                )}

                <div className="rustik-extras-panel" style={{ gridColumn: '1 / -1', padding: '15px', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0', marginTop: '10px' }}>
                  <div className="rustik-section-header" style={{ marginBottom: '15px' }}>
                    <h4 style={{ margin: 0, fontSize: '15px', color: '#b04309' }}>
                      <i className="fas fa-road" style={{ marginRight: '8px' }}></i>
                      Ray Seçenekleri
                    </h4>
                    <button
                      type="button"
                      onClick={() => {
                        const newList = [...(newOrder.rustikRaySecenekleri || []), { name: '', price: '0', quantity: newOrder.width || '1', cost: '', showCost: false }];
                        onFieldChange('rustikRaySecenekleri', newList);
                      }}
                      style={{ padding: '6px 12px', backgroundColor: '#0f172a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}
                    >
                      <i className="fas fa-plus" style={{ marginRight: '5px' }}></i>
                      Seçenek Ekle
                    </button>
                  </div>

                  {Array.isArray(newOrder.rustikRaySecenekleri) && newOrder.rustikRaySecenekleri.length > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
                      {newOrder.rustikRaySecenekleri.map((ray, idx) => (
                        <div key={idx} className={`rustik-item-block${ray.showCost ? ' is-cost-open' : ''}`}>
                          <div className="rustik-item-row">
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: '11px' }}>Seçenek Adı</label>
                              <input
                                type="text"
                                value={ray.name}
                                onChange={(e) => {
                                  const newList = [...newOrder.rustikRaySecenekleri];
                                  newList[idx].name = e.target.value;
                                  onFieldChange('rustikRaySecenekleri', newList);
                                }}
                                placeholder="Fırtına Ray vb."
                                style={{ padding: '6px' }}
                              />
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <div className="label-with-icon">
                                <label style={{ fontSize: '11px' }}>Birim Fiyat (₺/m)</label>
                                <button
                                  type="button"
                                  className={`lock-btn rustik-cost-toggle ${ray.showCost ? 'active' : ''}`}
                                  onClick={() => toggleRustikExtraCost('rustikRaySecenekleri', idx)}
                                  title={ray.showCost ? 'Maliyet alanını gizle' : 'Maliyet alanını göster'}
                                >
                                  <i className={`fas ${ray.showCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                                </button>
                              </div>
                              <input
                                type="number"
                                min="0"
                                onKeyDown={handleNumericKeyDown}
                                value={ray.price}
                                onChange={(e) => {
                                  const newList = [...newOrder.rustikRaySecenekleri];
                                  newList[idx].price = e.target.value;
                                  onFieldChange('rustikRaySecenekleri', newList);
                                }}
                                style={{ padding: '6px' }}
                              />
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: '11px' }}>Kullanılan Cm</label>
                              <input
                                type="text"
                                value={newOrder.usedCm || '-'}
                                readOnly
                                style={{ padding: '6px', backgroundColor: '#f1f5f9' }}
                              />
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: '11px' }}>Tutar (₺)</label>
                              <input
                                type="text"
                                value={formatPrice(calculateRustikRayLineTotal(ray.price, newOrder.usedCm))}
                                readOnly
                                style={{ padding: '6px', backgroundColor: '#f1f5f9' }}
                              />
                            </div>
                            <button
                              type="button"
                              onClick={() => {
                                const newList = newOrder.rustikRaySecenekleri.filter((_, i) => i !== idx);
                                onFieldChange('rustikRaySecenekleri', newList);
                              }}
                              style={{ padding: '8px', color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer' }}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </div>
                          {ray.showCost && (
                            <div className="rustik-item-cost-panel">
                              <div className="rustik-cost-panel-badge">
                                <i className="fas fa-shield-halved"></i>
                                <span>Gizli Maliyet</span>
                              </div>
                              <div className="form-group rustik-cost-field">
                                <label>Birim Maliyet (₺/m)</label>
                                <div className="rustik-cost-input-wrap">
                                  <span className="rustik-cost-prefix">₺</span>
                                  <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    onKeyDown={handleNumericKeyDown}
                                    value={ray.cost || ''}
                                    onChange={(e) => {
                                      const newList = [...newOrder.rustikRaySecenekleri];
                                      newList[idx].cost = e.target.value;
                                      onFieldChange('rustikRaySecenekleri', newList);
                                    }}
                                    placeholder="0,00"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={{ fontSize: '13px', color: '#64748b', textAlign: 'center', margin: '10px 0 20px 0' }}>Henüz ray seçeneği eklenmemiş.</p>
                  )}

                  <div className="rustik-section-header" style={{ marginBottom: '15px', borderTop: '1px solid #e2e8f0', paddingTop: '15px' }}>
                    <h4 style={{ margin: 0, fontSize: '15px', color: '#b04309' }}>
                      <i className="fas fa-tags" style={{ marginRight: '8px' }}></i>
                      Aksesuarlar
                    </h4>
                    <button
                      type="button"
                      onClick={() => {
                        const newList = [...(newOrder.rustikAksesuarlar || []), { name: '', price: '0', quantity: '1', cost: '', showCost: false }];
                        onFieldChange('rustikAksesuarlar', newList);
                      }}
                      style={{ padding: '6px 12px', backgroundColor: '#0f172a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}
                    >
                      <i className="fas fa-plus" style={{ marginRight: '5px' }}></i>
                      Aksesuar Ekle
                    </button>
                  </div>

                  {Array.isArray(newOrder.rustikAksesuarlar) && newOrder.rustikAksesuarlar.length > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      {newOrder.rustikAksesuarlar.map((acc, idx) => (
                        <div key={idx} className={`rustik-item-block${acc.showCost ? ' is-cost-open' : ''}`}>
                          <div className="rustik-item-row">
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: '11px' }}>Aksesuar Adı</label>
                              <input
                                type="text"
                                value={acc.name}
                                onChange={(e) => {
                                  const newList = [...newOrder.rustikAksesuarlar];
                                  newList[idx].name = e.target.value;
                                  onFieldChange('rustikAksesuarlar', newList);
                                }}
                                placeholder="Fisto, Boncuk vb."
                                style={{ padding: '6px' }}
                              />
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <div className="label-with-icon">
                                <label style={{ fontSize: '11px' }}>Fiyat (₺)</label>
                                <button
                                  type="button"
                                  className={`lock-btn rustik-cost-toggle ${acc.showCost ? 'active' : ''}`}
                                  onClick={() => toggleRustikExtraCost('rustikAksesuarlar', idx)}
                                  title={acc.showCost ? 'Maliyet alanını gizle' : 'Maliyet alanını göster'}
                                >
                                  <i className={`fas ${acc.showCost ? 'fa-lock-open' : 'fa-lock'}`}></i>
                                </button>
                              </div>
                              <input
                                type="number"
                                min="0"
                                onKeyDown={handleNumericKeyDown}
                                value={acc.price}
                                onChange={(e) => {
                                  const newList = [...newOrder.rustikAksesuarlar];
                                  newList[idx].price = e.target.value;
                                  onFieldChange('rustikAksesuarlar', newList);
                                }}
                                style={{ padding: '6px' }}
                              />
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: '11px' }}>Adet</label>
                              <input
                                type="number"
                                min="1"
                                onKeyDown={handleNumericKeyDown}
                                value={acc.quantity}
                                onChange={(e) => {
                                  const newList = [...newOrder.rustikAksesuarlar];
                                  newList[idx].quantity = e.target.value;
                                  onFieldChange('rustikAksesuarlar', newList);
                                }}
                                style={{ padding: '6px' }}
                              />
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: '11px' }}>Tutar (₺)</label>
                              <input
                                type="text"
                                value={formatPrice(parseFloat(acc.price) * parseFloat(acc.quantity) || 0)}
                                readOnly
                                style={{ padding: '6px', backgroundColor: '#f1f5f9' }}
                              />
                            </div>
                            <button
                              type="button"
                              onClick={() => {
                                const newList = newOrder.rustikAksesuarlar.filter((_, i) => i !== idx);
                                onFieldChange('rustikAksesuarlar', newList);
                              }}
                              style={{ padding: '8px', color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer' }}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </div>
                          {acc.showCost && (
                            <div className="rustik-item-cost-panel">
                              <div className="rustik-cost-panel-badge">
                                <i className="fas fa-shield-halved"></i>
                                <span>Gizli Maliyet</span>
                              </div>
                              <div className="form-group rustik-cost-field">
                                <label>Birim Maliyet (₺)</label>
                                <div className="rustik-cost-input-wrap">
                                  <span className="rustik-cost-prefix">₺</span>
                                  <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    onKeyDown={handleNumericKeyDown}
                                    value={acc.cost || ''}
                                    onChange={(e) => {
                                      const newList = [...newOrder.rustikAksesuarlar];
                                      newList[idx].cost = e.target.value;
                                      onFieldChange('rustikAksesuarlar', newList);
                                    }}
                                    placeholder="0,00"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={{ fontSize: '13px', color: '#64748b', textAlign: 'center', margin: '10px 0' }}>Henüz aksesuar eklenmemiş.</p>
                  )}
                </div>

                <div className="form-group">
                  <label>Adet *</label>
                  <input
                    type="number"
                    value={newOrder.quantity}
                    onChange={(e) => onFieldChange('quantity', e.target.value)}
                    min="1"
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label>İskonto (%)</label>
                  <input
                    type="number"
                    value={newOrder.discount}
                    onChange={(e) => onFieldChange('discount', e.target.value)}
                    min="0"
                    max="100"
                    disabled={isLoading}
                  />
                </div>

                {newOrder.totalPrice && (
                  <div className="form-group">
                    <label>Toplam Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.totalPrice)}
                      readOnly
                      className="total-price"
                    />
                  </div>
                )}

                {newOrder.discountedPrice && parseFloat(newOrder.discount) > 0 && (
                  <div className="form-group">
                    <label>İndirimli Tutar (₺)</label>
                    <input
                      type="text"
                      value={formatPrice(newOrder.discountedPrice)}
                      readOnly
                      className="discounted-price"
                    />
                  </div>
                )}
              </>
            )}

            <div className="form-group">
              <label>Not</label>
              <textarea
                value={newOrder.notes}
                onChange={(e) => onFieldChange('notes', e.target.value)}
                rows="2"
                disabled={isLoading}
              />
            </div>
          </div>
        )
        }

        <div className="form-actions">
          <div className="action-buttons">
            <button
              type="submit"
              className="save-btn"
              disabled={isLoading || !selectedProductType}
            >
              {isLoading ? 'Kaydediliyor...' : 'Kaydet'}
            </button>
            <button
              type="button"
              onClick={onCancel}
              className="cancel-btn"
              disabled={isLoading}
            >
              İptal
            </button>
          </div>

          {/* WhatsApp Gönderme Bölümü - Sağ tarafta */}
          {selectedProductType && (newOrder.productName || (selectedProductType === 'plise' && newOrder.pliseProduct1Name)) && newOrder.roomName && (
            <div className="whatsapp-section-right">
              {selectedProductType === 'katlamaliPerde' ? (
                /* Katlamalı Perde için Özel 4'lü Firma Seçimi */
                <div className="katlamali-whatsapp-grid">
                  {[
                    { id: 'kumas', label: 'Kumaş Firması', value: selectedFirmaKumas, setter: setSelectedFirmaKumas, lastSent: lastSentFirmaKumas },
                    { id: 'mekanizma', label: 'Mekanizma Firması', value: selectedFirmaMekanizma, setter: setSelectedFirmaMekanizma, lastSent: lastSentFirmaMekanizma },
                    { id: 'motor', label: 'Motor Firması', value: selectedFirmaMotor, setter: setSelectedFirmaMotor, lastSent: lastSentFirmaMotor },
                    { id: 'aksesuar', label: 'Aksesuar Firması', value: selectedFirmaAksesuar, setter: setSelectedFirmaAksesuar, lastSent: lastSentFirmaAksesuar }
                  ].map((item) => (
                    <div key={item.id} className="whatsapp-control-row">
                      <div className="whatsapp-row-header">
                        <span className="row-label">{item.label}</span>
                        {item.lastSent && (
                          <span className="row-sent-info">
                            <i className="fas fa-check"></i> {item.lastSent.name}
                          </span>
                        )}
                      </div>
                      <div className="whatsapp-controls">
                        <Select
                          options={companies.map(firma => ({ value: firma.id, label: firma.name }))}
                          value={item.value ? { value: item.value, label: companies.find(f => f.id === item.value)?.name } : null}
                          onChange={(option) => item.setter(option ? option.value : '')}
                          className="firma-select"
                          isDisabled={isLoading}
                          isClearable
                          isSearchable
                          placeholder="Firma Seçin"
                          styles={customSelectStyles}
                        />
                        <button
                          type="button"
                          onClick={() => handleKatlamaliWhatsAppSend(item.id)}
                          disabled={!item.value || isLoading}
                          className="whatsapp-btn"
                          title={`${item.label} bilgilerini gönder`}
                        >
                          <i className="fab fa-whatsapp"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                /* Diğer Ürünler için Standart Firma Seçimi */
                <>
                  {lastSentFirma && (
                    <div className="whatsapp-info">
                      <i className="fas fa-check-circle"></i>
                      <span>{lastSentFirma.name} firmasına bilgiler iletildi</span>
                    </div>
                  )}

                  <div className="whatsapp-controls">
                    <Select
                      options={companies.map(firma => ({ value: firma.id, label: firma.name }))}
                      value={selectedFirma ? { value: selectedFirma, label: companies.find(f => f.id === selectedFirma)?.name } : null}
                      onChange={(option) => setSelectedFirma(option ? option.value : '')}
                      className="firma-select"
                      isDisabled={isLoading}
                      isClearable
                      isSearchable
                      placeholder="Firma Seçin"
                      noOptionsMessage={() => "Firma bulunamadı"}
                      filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                      styles={customSelectStyles}
                    />
                    <button
                      type="button"
                      onClick={handleWhatsAppSend}
                      disabled={!selectedFirma || isLoading || !selectedProductType}
                      className="whatsapp-btn"
                      title="Seçilen firmaya WhatsApp ile gönder"
                    >
                      <i className="fab fa-whatsapp"></i>
                      <span>Gönder</span>
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </form >
    </div >
  );
};

export default OrderForm; 